<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (eventPlayersReady$ | async) {
  <app-screen-shell
    [contentClass]="'container'"
    [title]="matchScreenTitle()"
    [titleActionable]="isMatchTitleActionable()"
    [titleActionLabelKey]="matchInfoEditorMode ? 'events.details' : 'events.editMatchName'"
    (titleAction)="handleMatchTitleClick()"
    (back)="handleMatchScreenBack()">
      <div screen-header-actions *ngIf="event.viewedByManager && canUseLiveMatchActions(event) && !matchInfoEditorMode">
        <button type="button" class="btn btn-outline-primary" (click)="showNewNogoshUserDialog = true" data-testid="match-detail-invite">
          <i [class]="'common.share' | nogoshIcon" aria-hidden="true"></i> {{ 'players.invite' | translate }}
        </button>
      </div>
      <app-invite-link-sheet *ngIf="showNewNogoshUserDialog && event.viewedByManager" [match]="event" [eventId]="event.id" [matchName]="event.name" (closed)="showNewNogoshUserDialog = false"></app-invite-link-sheet>
      <app-dialog [(visible)]="showDeleteMatchDialog" [closable]="false" class="app-dialog--confirm">
        <div class="modal-header">
          <h5 class="mb-0 text-danger">{{ 'events.deleteTeam' | translate }}</h5>
        </div>
        <div class="modal-body">
          <p class="mb-2">{{ 'events.deleteTeamDescription' | translate }}</p>
          <p class="mb-0">{{ 'events.deleteTeamCannotUndo' | translate }}</p>
          @if (deleteMatchErrorMsg) {
            <div class="alert alert-danger mt-3 mb-0" role="alert">
              {{ deleteMatchErrorMsg }}
            </div>
          }
        </div>
        <div class="modal-footer justify-content-start">
          <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="deleteMatchLoading" (click)="showDeleteMatchDialog = false">{{ 'common.cancel' | translate }}</button>
          <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="deleteMatchLoading" (click)="deleteMatchSeries()">
            @if (deleteMatchLoading) {
              <app-delayed-indicator></app-delayed-indicator>
            }
            {{ 'events.deleteTeam' | translate }}
          </button>
        </div>
      </app-dialog>
      <app-dialog [(visible)]="showMatchTimeEditor">
        <div class="modal-header match-time-editor-header">
          <div>
            <h5 class="mb-1">{{ 'events.editMatchTime' | translate }}</h5>
          </div>
        </div>
        <div class="modal-body match-time-editor-body">
	          <section class="match-time-editor-section">
	            <div class="match-time-editor-datepicker">
	              <bs-datepicker-inline [(bsValue)]="selectedDate" name="matchLandingDate" id="matchLandingDateEdit" [minDate]="currentDate" [showWeeks]="false" class="d-picker" [bsConfig]="bsConfig"></bs-datepicker-inline>
	            </div>
	          </section>
          <section class="match-time-editor-section mb-0">
            <div class="match-time-editor-range">
              <div class="match-time-editor-range-header">
                <label for="matchLandingHoursRange">{{ 'events.hour' | translate }}</label>
                <span>{{ selectedHour != 0 ? ((selectedHour < 10 ? '0' : '' ) + selectedHour) : '00' }}</span>
              </div>
              <input class="custom-range" type="range" id="matchLandingHoursRange" [(ngModel)]="selectedHour" name="matchLandingSelectedHour" min="0" max="23" step="1">
            </div>
            <div class="match-time-editor-range">
              <div class="match-time-editor-range-header">
                <label for="matchLandingMinutesRange">{{ 'events.minute' | translate }}</label>
                <span>{{ selectedMinute !=0 ? ((selectedMinute < 10 ? '0' : '' ) + selectedMinute) : '00' }}</span>
              </div>
              <input class="custom-range" type="range" id="matchLandingMinutesRange" [(ngModel)]="selectedMinute" name="matchLandingSelectedMinute" min="0" max="59" step="1">
            </div>
          </section>
          @if (matchInfoErrorMsg) {
            <div class="alert alert-danger mt-3 mb-0" role="alert">{{ matchInfoErrorMsg }}</div>
          }
        </div>
        <div class="modal-footer match-time-editor-footer">
          <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>
          @if (hasMatchTime()) {
            <button type="button" class="btn btn-outline-danger btn-sm px-3" [disabled]="matchInfoSaving" (click)="clearMatchTime()">{{ 'events.clearMatchTime' | translate }}</button>
          }
          <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchTime()">{{ 'common.save' | translate }}</button>
        </div>
      </app-dialog>
      <app-dialog [(visible)]="showMatchLocationEditor" class="match-location-editor-dialog">
        <div class="modal-header">
          <h5 class="mb-0">{{ 'events.editMatchLocation' | translate }}</h5>
        </div>
        <div class="modal-body">
          <div class="btn-group btn-group-sm match-location-editor-options mb-3" role="group" [attr.aria-label]="'events.locationOptions' | translate">
            <button type="button" class="btn" [ngClass]="locationEditorMode === 'name' ? 'btn-primary' : 'btn-outline-primary'" (click)="selectLocationEditorMode('name')">
              {{ 'events.locationNameOnly' | translate }}
            </button>
            <button type="button" class="btn" [ngClass]="locationEditorMode === 'existing' ? 'btn-primary' : 'btn-outline-primary'" (click)="selectLocationEditorMode('existing')">
              {{ 'events.locationExisting' | translate }}
            </button>
            <button type="button" class="btn btn-outline-primary" [disabled]="matchInfoSaving" (click)="createNewMapLocation()">
              {{ 'events.locationCreateMap' | translate }}
            </button>
          </div>
          @if (locationEditorMode === 'name') {
            <div class="form-group mb-0">
              <label for="matchLandingLocationName" class="m-0">{{ 'events.locationNameOnlyLabel' | translate }}</label>
              <input [(ngModel)]="autocompletePlayspace" autocomplete="off"
                name="matchLandingLocationNameText" [placeholder]="'events.locationPlaceholder' | translate" class="form-control" id="matchLandingLocationName">
              <div class="small text-nogosh-grey3 mt-2">{{ 'events.locationNameOnlyHint' | translate }}</div>
            </div>
          }
          @if (locationEditorMode === 'existing' && !canSelectExistingLocations()) {
            <div class="alert alert-info location-profile-notice py-2 mb-0" role="status">
              {{ 'events.locationExistingRequiresProfileLocation' | translate }}
              <a [routerLink]="['/player-detail', false]" class="alert-link">{{ 'events.updateProfileCity' | translate }}</a>
            </div>
          }
          @if (locationEditorMode === 'existing' && canSelectExistingLocations()) {
            <div class="form-group mb-0">
              <label for="matchLandingExistingLocationName" class="m-0">{{ 'events.locationExistingLabel' | translate }}</label>
              <input [(ngModel)]="autocompletePlayspace" (blur)="checkIfLocationNameIsSelected()" autocomplete="off"
                name="matchLandingLocationNamePicker" [typeahead]="locationDataSource"
                typeaheadWaitMs="500"
                typeaheadOptionsLimit="8"
                [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="6"
                (typeaheadOnSelect)="typeaheadLocationNameSelected($event)"
                (typeaheadLoading)="changeTypeaheadLoading($event, 'locationName')"
                (typeaheadNoResults)="changeTypeaheadNoResults($event, 'locationName')" typeaheadOptionField="name"
                [placeholder]="'events.locationExistingPlaceholder' | translate" class="form-control" id="matchLandingExistingLocationName">
              @if (typeaheadLocationLoading === true) {
                <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
              }
              @if (typeaheadLocationNoResults === true) {
                <div class="small text-nogosh-grey3 mt-2">{{ 'events.locationExistingNoResults' | translate }}</div>
              }
              @if (shouldShowNearbyPlaySpaces()) {
                <div class="match-location-nearby mt-3">
                  @if (nearbyPlaySpacesLoading) {
                    <app-loading-state titleKey="events.locationExistingNearbyLoading" [compact]="true"></app-loading-state>
                  }
                  @if (!nearbyPlaySpacesLoading && nearbyPlaySpacesError) {
                    <div class="small text-danger">{{ 'events.locationExistingNearbyError' | translate }}</div>
                  }
                @if (!nearbyPlaySpacesLoading && !nearbyPlaySpacesError && locatedNearbyPlaySpacesCache.length === 0) {
                  <div class="small text-nogosh-grey3">{{ 'events.locationExistingNearbyEmpty' | translate }}</div>
                }
                @if (!nearbyPlaySpacesLoading && locatedNearbyPlaySpacesCache.length > 0) {
                  <google-map [options]="nearbyLocationsMapOptionsCache" height="320px" width="100%">
                    @for (playSpace of locatedNearbyPlaySpacesCache; track playSpace.id || playSpace.name; let markerNo = $index) {
                        <map-advanced-marker #marker="mapAdvancedMarker" (markerInitialized)="bindLocationMarkerClick(marker, $event, playSpace, markerNo)" [options]="locationMarkerOptions(playSpace)" [position]="playSpaceMapPosition(playSpace)" [zIndex]="isSelectedExistingPlaySpace(playSpace) ? 1000 : 1">
                          <map-info-window>
                            <div class="map-info-card">
                              <div class="map-info-title">{{ playSpace.name }}</div>
                              @if (playSpace.address) {
                                <div class="map-info-row">
                                  <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                                  <span>{{ playSpace.address }}</span>
                                </div>
                              }
                              <button type="button" class="btn btn-sm btn-primary map-info-action" (click)="selectExistingPlaySpace(playSpace)">
                                {{ 'events.selectLocation' | translate }}
                              </button>
                            </div>
                          </map-info-window>
                        </map-advanced-marker>
                      }
                    </google-map>
                  }
                </div>
              }
            </div>
          }
          @if (matchInfoErrorMsg) {
            <div class="alert alert-danger mt-3 mb-0" role="alert">{{ matchInfoErrorMsg }}</div>
          }
        </div>
        <div class="modal-footer justify-content-start match-location-editor-footer">
          <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>
          @if (eventLocationValue()) {
            <button type="button" class="btn btn-outline-danger btn-sm px-3" [disabled]="matchInfoSaving" (click)="clearMatchLocation()">{{ 'events.locationRemove' | translate }}</button>
          }
          <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchLocation()">{{ 'common.save' | translate }}</button>
        </div>
      </app-dialog>
      <app-dialog [(visible)]="showLeaveTeamDialog" [closable]="false" class="app-dialog--confirm">
        <div class="modal-header">
          <h5 class="mb-0 text-danger">{{ leaveTeamConfirmTitleKey(event) | translate }}</h5>
        </div>
        <div class="modal-body">
          <p class="mb-0">{{ leaveTeamConfirmDescriptionKey(event) | translate:{ match: event.name } }}</p>
        </div>
        <div class="modal-footer justify-content-start">
          <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="leaveTeamInProgress" (click)="showLeaveTeamDialog = false">{{ 'common.cancel' | translate }}</button>
          <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="leaveTeamInProgress" (click)="leaveEvent(event)">
            @if (leaveTeamInProgress) {
              <app-delayed-indicator></app-delayed-indicator>
            }
            {{ leaveTeamActionKey(event) | translate }}
          </button>
        </div>
      </app-dialog>
    @if (matchInfoEditorMode) {
      <section class="match-info-edit-screen col-lg-8 mx-auto"
        [class.is-screen-entering]="matchInfoScreenEntering"
        [class.is-screen-exiting]="matchInfoScreenExiting"
        [ngClass]="{'match-info-edit-screen-wide': matchInfoEditorMode === 'playerDetail' || matchInfoEditorMode === 'playerManagement', 'match-info-edit-screen-player-management': matchInfoEditorMode === 'playerManagement', 'match-info-edit-screen-player-detail': matchInfoEditorMode === 'playerDetail', 'match-info-edit-screen-player-settings': matchInfoEditorMode === 'settings' && canUsePlayerSettings(event)}">
        @if (matchInfoEditorMode === 'changes') {
          <section class="match-changes"><h2>{{ 'events.managerImportantChangesTitle' | translate }}</h2>
            <div *ngFor="let change of event.managerHome?.importantChanges" class="match-home-change"><span>{{ importantChangeText(change) }}</span></div>
            <div class="match-overview-actions"><button type="button" class="btn btn-secondary" [disabled]="changesSaving" (click)="closeMatchInfoEditor()">{{ 'common.close' | translate }}</button><button type="button" class="btn btn-primary" [disabled]="changesSaving" (click)="acknowledgeImportantChanges()">{{ 'common.ok' | translate }}</button></div>
            <button class="btn btn-outline-primary mt-3" (click)="openOverviewRoster()">{{ 'events.managerOpenRoster' | translate }}</button>
          </section>
        }
        @if (matchInfoEditorMode === 'settings') {
          <div>
            <div class="add-players-screen-options subscreen-menu-options">
              @if (event.viewedByManager && canUseLiveMatchActions(event)) {
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchTimeEditor(true)">
                  <i [class]="'match.time' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.time' | translate }}</span>
                    <small>
                      @if (event.nextOccurrenceTimestamp) {
                        {{ event.nextOccurrenceTimestamp | localizedDate:'EEE, d MMM' }} &#64; {{ event.nextOccurrenceTimestamp | timezone:event.nextOccurrenceTimestampZone:'HH:mm' }}
                      } @else {
                        {{ 'events.timeNotSet' | translate }}
                      }
                    </small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchLocationEditor(true)">
                  <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'common.location' | translate }}</span>
                    <small>{{ matchSettingsLocationStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchMaxPlayersEditor()">
                  <i [class]="'match.maxPlayers' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.maxPlayers' | translate }}</span>
                    <small>{{ matchSettingsMaxPlayersStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchOccurrenceEditor()">
                  <i [class]="'match.recurring' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.settingsSetOccurrence' | translate }}</span>
                    <small>{{ matchSettingsOccurrenceStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchRulesEditor()">
                  <i [class]="'match.rulebook' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.settingsSetRules' | translate }}</span>
                    <small>{{ matchSettingsRulesStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchVisibilityEditor()">
                  <i [class]="event.openToPublic ? ('match.visibilityOpen' | nogoshIcon) : ('match.visibility' | nogoshIcon)" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.visibility' | translate }}</span>
                    <small>{{ matchSettingsVisibilityStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchManagerEditor()">
                  <i [class]="'player.security' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'common.manager' | translate }}</span>
                    <small>{{ matchSettingsManagerStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openPlayerManagementEditor(event)">
                  <i [class]="'match.editPlayers' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.players' | translate }}</span>
                    <small>{{ matchSettingsPlayersStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openMatchSeasonsEditor()">
                  <i [class]="'match.seasons' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.settingsSetSeasons' | translate }}</span>
                    <small>{{ matchSettingsSeasonsStatus() }}</small>
                  </span>
                </button>
                <button type="button" class="add-players-screen-option subscreen-menu-option text-danger match-settings-danger-option" (click)="openCancelMatchEditor()">
                  <i [class]="'match.cancel' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.cancelMatch' | translate }}</span>
                    <small>{{ 'events.cancelMatchMenuDescription' | translate }}</small>
                  </span>
                </button>
              }
              @if (event.cancelled === true && event.viewedByManager) {
                <button type="button" class="add-players-screen-option subscreen-menu-option text-danger match-settings-danger-option" [disabled]="uncancelMatchInProgress" (click)="uncancelMatch()">
                  <i [class]="'match.uncancel' | nogoshIcon" aria-hidden="true"></i>
                  <span class="match-settings-option-copy">
                    <span>{{ 'events.uncancelMatch' | translate }}</span>
                    <small>{{ 'events.uncancelMatchMenuDescription' | translate }}</small>
                  </span>
                </button>
                @if (uncancelMatchErrorMsg) {
                  <div class="alert alert-danger mt-3" role="alert">{{ uncancelMatchErrorMsg }}</div>
                }
              }
              @if (event.cancelled !== true && (!event.viewedByManager || !canUseLiveMatchActions(event)) && !canUsePlayerSettings(event)) {
                <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="viewEvent(event)">
                  <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
                  <span>{{ 'common.details' | translate }}</span>
                </button>
              }
              @if (event.viewedByManager) {
                <button type="button" class="add-players-screen-option subscreen-menu-option text-danger" (click)="openDeleteMatchDialog()">
                  <i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i>
                  <span>{{ 'events.deleteTeam' | translate }}</span>
                </button>
              }
              @if (canUsePlayerSettings(event)) {
                <button type="button" class="add-players-screen-option subscreen-menu-option text-danger match-settings-danger-option" (click)="openLeaveTeamDialog(event)">
                  <i [class]="'auth.logout' | nogoshIcon" aria-hidden="true"></i>
                  <span>{{ leaveTeamActionKey(event) | translate }}</span>
                </button>
              }
            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'visibility') {
          <div class="match-visibility-editor">
            <div class="match-player-count-card">
              <div class="match-player-count-icon">
                <i [class]="visibilityOpenDraft ? ('match.visibilityOpen' | nogoshIcon) : ('match.visibility' | nogoshIcon)" aria-hidden="true"></i>
              </div>
              <div class="match-occurrence-options" role="radiogroup" [attr.aria-label]="'events.visibility' | translate">
                <button type="button"
                  class="match-occurrence-option"
                  role="radio"
                  [attr.aria-checked]="visibilityOpenDraft"
                  [class.is-active]="visibilityOpenDraft"
                  [disabled]="matchInfoSaving"
                  (click)="setVisibilityOpenDraft(true)">
                  <i [class]="'match.visibilityOpen' | nogoshIcon" aria-hidden="true"></i>
                  <span>
                    <strong>{{ 'events.openMatch' | translate }}</strong>
                    <small>{{ 'events.visibilityOpen' | translate }}</small>
                  </span>
                </button>
                <button type="button"
                  class="match-occurrence-option"
                  role="radio"
                  [attr.aria-checked]="!visibilityOpenDraft"
                  [class.is-active]="!visibilityOpenDraft"
                  [disabled]="matchInfoSaving"
                  (click)="setVisibilityOpenDraft(false)">
                  <i [class]="'match.visibility' | nogoshIcon" aria-hidden="true"></i>
                  <span>
                    <strong>{{ 'events.visibilityClosedTitle' | translate }}</strong>
                    <small>{{ 'events.visibilityClosed' | translate }}</small>
                  </span>
                </button>
              </div>
              @if (visibilityOpenDraft && !hasPrecisePlaySpaceLocation()) {
                <p class="text-nogosh-grey3 small mt-3 mb-0">{{ 'events.openMatchLocationSuggestion' | translate }}</p>
              }
            </div>
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchVisibility()">{{ 'common.save' | translate }}</button>

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'name') {
          <div>
            <div class="form-group">
              <input [(ngModel)]="matchNameDraft" autocomplete="off"
                name="matchLandingNameScreen"
                [placeholder]="'validation.matchName' | translate"
                class="form-control"
                id="matchLandingNameScreen"
                maxlength="50"
                required>
            </div>
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ (rulesReadOnly ? 'common.close' : 'common.cancel') | translate }}</button>

              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchName()">{{ 'common.save' | translate }}</button>

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'cancelMatch') {
          <div class="match-cancel-editor">
            <div class="subscreen-intro">
              <h3>{{ 'events.cancelMatchTitle' | translate }}</h3>
              <p>{{ 'events.cancelMatchDescription' | translate }}</p>
            </div>
            <label for="cancelMatchReason" class="match-location-field-card">
              <span>{{ 'events.cancelMatchReasonLabel' | translate }}</span>
              <textarea id="cancelMatchReason" name="cancelMatchReason" class="form-control" rows="3" [(ngModel)]="cancelMatchReason" [placeholder]="'events.cancelMatchReasonPlaceholder' | translate"></textarea>
            </label>
            <div class="match-cancel-player-message">
              <i [class]="'match.notify.sosOther' | nogoshIcon" aria-hidden="true"></i>
              <span>{{ 'events.cancelMatchPlayerMessagePreview' | translate }}</span>
            </div>
            @if (cancelMatchErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ cancelMatchErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="cancelMatchInProgress" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="cancelMatchInProgress" (click)="cancelMatch()">
                @if (cancelMatchInProgress) {
                  <app-delayed-indicator></app-delayed-indicator>
                }
                {{ 'events.cancelMatch' | translate }}
              </button>

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'time') {
          <div>
            <section class="match-time-editor-section">
              <div class="match-time-editor-datepicker">
                <bs-datepicker-inline [(bsValue)]="selectedDate" name="matchLandingDateScreen" id="matchLandingDateScreen" [minDate]="currentDate" [showWeeks]="false" class="d-picker" [bsConfig]="bsConfig"></bs-datepicker-inline>
              </div>
            </section>
            <section class="match-time-editor-section mb-0">
              <div class="match-time-editor-range">
                <div class="match-time-editor-range-header">
                  <label for="matchLandingHoursRangeScreen">{{ 'events.hour' | translate }}</label>
                  <span>{{ selectedHour != 0 ? ((selectedHour < 10 ? '0' : '' ) + selectedHour) : '00' }}</span>
                </div>
                <input class="custom-range" type="range" id="matchLandingHoursRangeScreen" [(ngModel)]="selectedHour" name="matchLandingSelectedHourScreen" min="0" max="23" step="1">
              </div>
              <div class="match-time-editor-range">
                <div class="match-time-editor-range-header">
                  <label for="matchLandingMinutesRangeScreen">{{ 'events.minute' | translate }}</label>
                  <span>{{ selectedMinute !=0 ? ((selectedMinute < 10 ? '0' : '' ) + selectedMinute) : '00' }}</span>
                </div>
                <input class="custom-range" type="range" id="matchLandingMinutesRangeScreen" [(ngModel)]="selectedMinute" name="matchLandingSelectedMinuteScreen" min="0" max="59" step="1">
              </div>
            </section>
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>
              @if (hasMatchTime()) {
                <button type="button" class="btn btn-outline-danger btn-sm px-3" [disabled]="matchInfoSaving" (click)="clearMatchTime()">{{ 'events.clearMatchTime' | translate }}</button>
              }
              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchTime()">{{ 'common.save' | translate }}</button>


            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'location') {
          <div class="match-location-screen-editor">
            @if (locationDetailPlaySpace) {
              <section class="match-location-detail-picker">
                <section class="match-location-detail-card">
                  <div class="match-location-detail-summary">
                    <span class="match-location-detail-pin"><i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i></span>
                    <div class="match-location-detail-copy">
                      <span>{{ 'common.address' | translate }}</span>
                      <strong>{{ playSpaceAddressLine(locationDetailPlaySpace) || ('locations.addressMissing' | translate) }}</strong>
                    </div>
                  </div>

                  @if (hasPlaySpaceText(locationDetailPlaySpace.phone)) {
                    <div class="match-location-detail-row">
                      <i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ 'common.phone' | translate }}</span>
                      <strong>{{ locationDetailPlaySpace.phone }}</strong>
                    </div>
                  }
                  @if (hasPlaySpaceText(locationDetailPlaySpace.workingHours)) {
                    <div class="match-location-detail-row">
                      <i [class]="'match.time' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ 'locations.workingHours' | translate }}</span>
                      <strong>{{ locationDetailPlaySpace.workingHours }}</strong>
                    </div>
                  }
                  @if (locationDetailPlaySpace.manager && hasPlaySpaceText(locationDetailPlaySpace.manager.name)) {
                    <div class="match-location-detail-row">
                      <i [class]="'player.profile' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ 'common.manager' | translate }}</span>
                      <strong>{{ locationDetailPlaySpace.manager.name }}</strong>
                    </div>
                  }
                  @if (hasPlaySpaceText(locationDetailPlaySpace.webAddress)) {
                    <div class="match-location-detail-row">
                      <i [class]="'locations.website' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ 'locations.website' | translate }}</span>
                      <strong>{{ locationDetailPlaySpace.webAddress }}</strong>
                    </div>
                  }
                </section>

                <button type="button" class="btn btn-primary match-location-use-button" (click)="useLocationDetailPlaySpace()">
                  <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
                  {{ 'locations.useThisLocation' | translate }}
                </button>

                @if (locationDetailMarkerPositionCache) {
                  <div class="match-location-map-card">
                    <google-map [options]="locationDetailMapOptionsCache" height="260px" width="100%">
                      <map-advanced-marker [position]="locationDetailMarkerPositionCache"></map-advanced-marker>
                    </google-map>
                  </div>
                }
              </section>
            } @else {
            <section class="match-location-picker-toolbar" [attr.aria-label]="'events.locationOptions' | translate">
              <div class="match-location-picker-search-row">
                <label class="match-location-picker-search" for="matchLandingExistingLocationNameScreen">
                  <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
                  <input [(ngModel)]="autocompletePlayspace" (ngModelChange)="onMatchLocationSearchChanged()" (blur)="checkIfLocationNameIsSelected()" autocomplete="off"
                    name="matchLandingLocationNamePickerScreen" [typeahead]="locationDataSource"
                    typeaheadWaitMs="500"
                    typeaheadOptionsLimit="8"
                    [typeaheadScrollable]="true"
                    [typeaheadOptionsInScrollableView]="6"
                    (typeaheadOnSelect)="typeaheadLocationNameSelected($event)"
                    (typeaheadLoading)="changeTypeaheadLoading($event, 'locationName')"
                    (typeaheadNoResults)="changeTypeaheadNoResults($event, 'locationName')" typeaheadOptionField="name"
                    [placeholder]="'locations.searchPlaceholder' | translate" id="matchLandingExistingLocationNameScreen">
                  @if (shouldShowMatchLocationClearDraft()) {
                    <button type="button" class="match-location-remove-icon" [disabled]="matchInfoSaving" (click)="removeMatchLocationDraft()" [attr.aria-label]="'events.locationRemove' | translate" [attr.title]="'events.locationRemove' | translate">
                      <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                    </button>
                  }
                </label>
                <button type="button" class="match-location-picker-add" [disabled]="matchInfoSaving" (click)="createNewMapLocation()" [attr.aria-label]="'locations.new' | translate">
                  <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
                </button>
              </div>
              @if (canSelectExistingLocations()) {
                <div class="match-location-picker-tabs" role="tablist" [attr.aria-label]="'locations.viewOptions' | translate">
                  <button type="button" [class.active]="locationPickerView === 'list'" (click)="setLocationPickerView('list')">
                    <i [class]="'locations.list' | nogoshIcon" aria-hidden="true"></i>
                    <span>{{ 'locations.listView' | translate }}</span>
                  </button>
                  <button type="button" [class.active]="locationPickerView === 'map'" (click)="setLocationPickerView('map')">
                    <i [class]="'locations.map' | nogoshIcon" aria-hidden="true"></i>
                    <span>{{ 'locations.mapView' | translate }}</span>
                  </button>
                </div>
              }
            </section>
            @if (!canSelectExistingLocations()) {
              <div class="alert alert-info location-profile-notice py-2" role="status">
                {{ 'events.locationExistingRequiresProfileLocation' | translate }}
                <a [routerLink]="['/player-detail', false]" class="alert-link">{{ 'events.updateProfileCity' | translate }}</a>
              </div>
            }
            @if (canSelectExistingLocations()) {
              <div class="match-location-picker-content">
                @if (shouldShowLocationNameOnlyOption()) {
                  <div class="match-location-name-only-option" role="status">
                    <span class="match-location-name-only-icon"><i [class]="'common.text' | nogoshIcon" aria-hidden="true"></i></span>
                    <span class="match-location-name-only-main">
                      <span class="match-location-name-only-title">{{ autocompletePlayspace }}</span>
                      <span class="match-location-name-only-value">{{ 'events.locationUseNameOnly' | translate }}</span>
                    </span>
                  </div>
                }
                @if (!shouldShowLocationNameOnlyOption() && typeaheadLocationLoading === true) {
                  <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
                }
                @if (!shouldShowLocationNameOnlyOption() && typeaheadLocationNoResults === true) {
                  <div class="small text-nogosh-grey3 mt-2">{{ 'events.locationExistingNoResults' | translate }}</div>
                }
                @if (!shouldShowLocationNameOnlyOption() && nearbyPlaySpacesLoading) {
                  <app-loading-state titleKey="events.locationExistingNearbyLoading" [compact]="true"></app-loading-state>
                }
                @if (!shouldShowLocationNameOnlyOption() && !nearbyPlaySpacesLoading && nearbyPlaySpacesError) {
                  <div class="small text-danger">{{ 'events.locationExistingNearbyError' | translate }}</div>
                }
                @if (!shouldShowLocationNameOnlyOption() && !nearbyPlaySpacesLoading && !nearbyPlaySpacesError && visibleNearbyPlaySpaces().length === 0) {
                  <div class="small text-nogosh-grey3">{{ 'events.locationExistingNearbyEmpty' | translate }}</div>
                }
                @if (!shouldShowLocationNameOnlyOption() && !nearbyPlaySpacesLoading && locationPickerView === 'list' && visibleNearbyPlaySpaces().length > 0) {
                  <div class="match-location-picker-list">
                    @for (playSpace of visibleNearbyPlaySpaces(); track playSpace.id || playSpace.name) {
                      <button type="button" class="match-location-picker-row" [class.active]="isSelectedExistingPlaySpace(playSpace)" (click)="openMatchLocationDetail(playSpace)">
                        <span class="match-location-picker-row-pin"><i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i></span>
                        <span class="match-location-picker-row-main">
                          <span class="match-location-picker-row-title">{{ playSpace.name }}</span>
                          <span class="match-location-picker-row-address">{{ playSpace.address || ('locations.addressMissing' | translate) }}</span>
                        </span>
                        <span class="match-location-picker-row-chevron"><i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i></span>
                      </button>
                    }
                  </div>
                }
                @if (!shouldShowLocationNameOnlyOption() && !nearbyPlaySpacesLoading && locationPickerView === 'map' && visibleNearbyPlaySpaces().length > 0) {
                  <div class="match-location-map-card">
                    <google-map [options]="nearbyLocationsMapOptionsCache" height="260px" width="100%">
                      @for (playSpace of visibleNearbyPlaySpaces(); track playSpace.id || playSpace.name) {
                        <map-advanced-marker (markerInitialized)="bindLocationDetailMarkerClick($event, playSpace)" [options]="locationMarkerOptions(playSpace)" [position]="playSpaceMapPosition(playSpace)" [zIndex]="isSelectedExistingPlaySpace(playSpace) ? 1000 : 1"></map-advanced-marker>
                      }
                    </google-map>
                  </div>
                }
              </div>
            }
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions match-location-screen-actions">
              <button type="button" class="btn btn-secondary px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary px-3" [disabled]="matchInfoSaving" (click)="saveMatchLocation()">{{ 'common.save' | translate }}</button>

            </div>
            }
          </div>
        }
        @if (matchInfoEditorMode === 'manager') {
          <div class="match-manager-editor">
            @if (!selectedManagerDraft) {
              <section class="match-manager-editor-intro">
                <p>{{ 'events.changeManagerIntro' | translate }}</p>
              </section>
              <section class="match-manager-current-card">
                <span class="match-manager-current-avatar">
                  @if (event.manager?.avatar) {
                    <img [src]="event.manager.avatar"
                      onerror="this.src='../../assets/images/user1.jpg'"
                      [alt]="'accessibility.userProfileImage' | translate">
                  } @else {
                    <span class="avatar-team-fallback" [ngClass]="playerAvatarTone(event.manager)" aria-hidden="true">{{playerInitials(event.manager)}}</span>
                  }
                </span>
                <span class="match-manager-current-copy">
                  <span>{{ 'events.currentManager' | translate }}</span>
                  <strong>{{ currentManagerDisplayName() }}</strong>
                </span>
              </section>
              <div class="match-manager-search">
                <div class="invite-player-search-box">
                  <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
                  <input [(ngModel)]="managerSearchText"
                    name="managerSearchText"
                    id="eventPlayersManagerSearch"
                    autocomplete="off"
                    [placeholder]="'events.searchPlayers' | translate">
                  @if (managerSearchText) {
                    <button type="button"
                      class="invite-player-search-clear"
                      [attr.aria-label]="'common.clear' | translate"
                      (click)="clearManagerSearch()">
                      <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                    </button>
                  }
                </div>
              </div>
              <div class="card player-section-card match-manager-picker-card">
                @if (managerCandidateEventInfos().length === 0) {
                  <div class="card-body text-center text-nogosh-grey3">{{ 'common.noResults' | translate }}</div>
                }
                @for (playerEventInfo of managerCandidateEventInfos(); track playerEventInfo.player.id) {
                  <button type="button"
                    class="players-list match-manager-picker-option"
                    [ngClass]="{'is-selected': isSelectedManagerCandidate(playerEventInfo)}"
                    (click)="selectManagerCandidate(playerEventInfo.player)">
                    <div class="row player-row align-items-center">
                      <div class="col-auto pr-2 pr-sm-3">
                        <div class="avatar-team" [class.is-current-player-avatar]="isCurrentPlayer(playerEventInfo)">
                          @if (playerEventInfo.player.avatar) {
                            <img [src]="playerEventInfo.player.avatar"
                              onerror="this.src='../../assets/images/user1.jpg'" class="rounded-circle border" style="width: 40px; height: 40px"
                              [alt]="'accessibility.userProfileImage' | translate">
                          } @else {
                            <span class="rounded-circle border player-avatar-fallback avatar-team-fallback"
                              [ngClass]="playerEventInfoAvatarTone(playerEventInfo)" aria-hidden="true">{{getPlayerInitials(playerEventInfo)}}</span>
                          }
                        </div>
                      </div>
                      <div class="col pl-0 text-sm font-weight-500 players-nickname d-flex flex-column justify-content-center line-height-10"
                        title="{{playerEventInfo.player.nickName || playerEventInfo.player.name}}">
                        {{playerEventInfo.player.nickName || playerEventInfo.player.name}}
                        @if (playerEventInfo.player.id === event.manager?.id) {
                          <span class="text-nogosh-grey3 text-sm mt-1">{{ 'common.manager' | translate }}</span>
                        }
                        @if (playerEventInfo.player.id !== event.manager?.id && playerEventInfo.teamMemberType === teamMemberType.RESERVE) {
                          <span class="text-nogosh-grey3 text-sm mt-1">{{ 'players.reserve' | translate }}</span>
                        }
                        @if (playerEventInfo.player.id !== event.manager?.id && playerEventInfo.teamMemberType === teamMemberType.FIRST_TEAM) {
                          <span class="text-nogosh-grey3 text-sm mt-1">{{ 'notifications.firstTeam' | translate }}</span>
                        }
                      </div>
                      <div class="col-auto align-items-center">
                        <i [class]="('match.chevronForward' | nogoshIcon) + ' h3 m-0'"></i>
                      </div>
                    </div>
                  </button>
                }
              </div>
            } @else {
              <section class="match-manager-candidate-detail">
                <div class="match-manager-candidate-card">
                  @if (selectedManagerDraft.avatar) {
                    <img [src]="selectedManagerDraft.avatar"
                      onerror="this.src='../../assets/images/user1.jpg'"
                      [alt]="'accessibility.userProfileImage' | translate">
                  } @else {
                    <span class="avatar-team-fallback" [ngClass]="playerAvatarTone(selectedManagerDraft)" aria-hidden="true">{{playerInitials(selectedManagerDraft)}}</span>
                  }
                  <div>
                    <strong>{{ selectedManagerDraftDisplayName() }}</strong>
                    @if (selectedManagerDraft.name && selectedManagerDraft.nickName && selectedManagerDraft.name !== selectedManagerDraft.nickName) {
                      <span>{{ selectedManagerDraft.name }}</span>
                    }
                  </div>
                </div>
                @if (!selectedManagerDraftIsCurrentManager()) {
                  <div class="alert alert-warning" role="alert">
                    {{ 'events.makeManagerWarning' | translate:{current: currentManagerDisplayName(), next: selectedManagerDraftDisplayName()} }}
                  </div>
                }
                @if (selectedManagerDraftIsCurrentManager()) {
                  <div class="alert alert-info" role="status">{{ 'events.alreadyCurrentManager' | translate }}</div>
                }
              </section>
            }
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              @if (selectedManagerDraft && !selectedManagerDraftIsCurrentManager()) {
                <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchManager()">
                  @if (matchInfoSaving) {
                    <app-delayed-indicator></app-delayed-indicator>
                  }
                  {{ 'players.setManagerConfirmTitle' | translate }}
                </button>
              }

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'seasons') {
          <div class="match-seasons-editor">
            <div class="match-seasons-intro">
              <div class="match-seasons-intro-icon">
                <i [class]="'match.rating' | nogoshIcon" aria-hidden="true"></i>
              </div>
              <div>
                <p class="match-seasons-intro-title mb-1">{{ 'events.seasonsIntroTitle' | translate }}</p>
                <p class="match-seasons-intro-copy mb-0">{{ 'events.seasonsIntroCopy' | translate }}</p>
              </div>
            </div>
            <div class="match-season-mode-options">
              <button type="button" class="match-season-mode-option" [class.active]="seasonModeDraft === 'INFINITE'" (click)="setSeasonModeDraft('INFINITE')">
                <span class="match-season-mode-icon"><i [class]="'match.infinity' | nogoshIcon" aria-hidden="true"></i></span>
                <span>
                  <span class="match-season-mode-title">{{ 'events.seasonModeInfinite' | translate }}</span>
                  <span class="match-season-mode-copy">{{ 'events.seasonModeInfiniteCopy' | translate }}</span>
                </span>
              </button>
              <button type="button" class="match-season-mode-option" [class.active]="seasonModeDraft === 'YEARLY'" (click)="setSeasonModeDraft('YEARLY')">
                <span class="match-season-mode-icon"><i [class]="'match.seasons' | nogoshIcon" aria-hidden="true"></i></span>
                <span>
                  <span class="match-season-mode-title">{{ 'events.seasonModeYearly' | translate }}</span>
                  <span class="match-season-mode-copy">{{ 'events.seasonModeYearlyCopy' | translate }}</span>
                </span>
              </button>
              <button type="button" class="match-season-mode-option" [class.active]="seasonModeDraft === 'CUSTOM'" (click)="setSeasonModeDraft('CUSTOM')">
                <span class="match-season-mode-icon"><i [class]="'match.sliders' | nogoshIcon" aria-hidden="true"></i></span>
                <span>
                  <span class="match-season-mode-title">{{ 'events.seasonModeCustom' | translate }}</span>
                  <span class="match-season-mode-copy">{{ 'events.seasonModeCustomCopy' | translate }}</span>
                </span>
              </button>
            </div>
            @if (seasonModeDraft === 'CUSTOM') {
              <div class="match-seasons-timeline" aria-hidden="true">
                @for (seasonStartDraft of seasonStartDateDrafts; track $index; let seasonIndex = $index) {
                  <span></span>
                }
              </div>
              <div class="match-season-cards">
                @for (seasonStartDraft of seasonStartDateDrafts; track $index; let seasonIndex = $index) {
                  <section class="match-season-card">
                    <div class="match-season-card-header">
                      <div class="match-season-badge">{{ seasonIndex + 1 }}</div>
                      <div>
                        <div class="match-season-title">{{ 'events.seasonStart' | translate:{number: seasonIndex + 1} }}</div>
                        <div class="match-season-date">{{ seasonStartDraft | localizedDate:'d MMM yyyy' }}</div>
                      </div>
                      <button type="button" class="match-season-remove" [disabled]="seasonStartDateDrafts.length <= 2" (click)="removeSeasonStartDraft(seasonIndex)" [attr.aria-label]="'events.removeSeasonStart' | translate:{number: seasonIndex + 1}">
                        <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                      </button>
                    </div>
                    <bs-datepicker-inline [bsValue]="seasonStartDateDrafts[seasonIndex]" (bsValueChange)="seasonStartDateDrafts[seasonIndex] = $event" name="matchSeasonStartScreen{{seasonIndex}}" id="matchSeasonStartScreen{{seasonIndex}}" [showWeeks]="false" class="d-picker match-season-picker" [bsConfig]="bsConfig"></bs-datepicker-inline>
                  </section>
                }
              </div>
              <div class="match-season-custom-actions">
                <button type="button" class="btn btn-outline-primary btn-sm px-3" [disabled]="seasonStartDateDrafts.length >= 12" (click)="addSeasonStartDraft()">
                  <i [class]="('common.plus' | nogoshIcon) + ' mr-1'" aria-hidden="true"></i>{{ 'events.addSeasonStart' | translate }}
                </button>
              </div>
            }
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchSeasons()">{{ 'common.save' | translate }}</button>

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'maxPlayers') {
          <div class="match-player-count-editor">
            <div class="match-player-count-card">
              <div class="match-player-count-icon">
                <i [class]="'match.maxPlayers' | nogoshIcon" aria-hidden="true"></i>
              </div>
              <div class="match-player-count-label">{{ 'events.maxPlayersPerGame' | translate }}</div>
              <div class="match-player-count-stepper" role="group" [attr.aria-label]="'events.maxPlayersPerGame' | translate">
                <button type="button" class="match-player-count-step" (click)="adjustMaxPlayers(-1)" [disabled]="matchInfoSaving || maxPlayersDraft <= 1" [attr.aria-label]="'common.decrease' | translate">
                  <i [class]="'common.minus' | nogoshIcon" aria-hidden="true"></i>
                </button>
                <output class="match-player-count-value" for="matchMaxPlayersScreen">{{ maxPlayersDraft || '-' }}</output>
                <button type="button" class="match-player-count-step" (click)="adjustMaxPlayers(1)" [disabled]="matchInfoSaving" [attr.aria-label]="'common.increase' | translate">
                  <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
                </button>
              </div>
              <input [(ngModel)]="maxPlayersDraft" type="number" min="1" step="1"
                name="matchMaxPlayersScreen"
                id="matchMaxPlayersScreen"
                class="sr-only"
                [attr.aria-label]="'events.maxPlayersPerGame' | translate">
              <div class="match-player-count-presets" role="group" [attr.aria-label]="'events.maxPlayersPerGame' | translate">
                @for (option of maxPlayersQuickOptions; track option) {
                  <button type="button"
                    class="match-player-count-preset"
                    [class.is-active]="maxPlayersDraft === option"
                    [disabled]="matchInfoSaving"
                    (click)="setMaxPlayersDraft(option)">
                    {{ option }}
                  </button>
                }
              </div>
            </div>
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchMaxPlayers()">{{ 'common.save' | translate }}</button>

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'occurrence') {
          <div class="match-occurrence-editor">
            <div class="match-player-count-card">
              <div class="match-player-count-icon">
                <i [class]="'match.recurring' | nogoshIcon" aria-hidden="true"></i>
              </div>
              <div class="match-player-count-label">{{ 'events.occurrenceLabel' | translate }}</div>
              <div class="match-occurrence-options" role="radiogroup" [attr.aria-label]="'events.occurrenceLabel' | translate">
                @for (option of recurringTypeOptions; track option.value) {
                  <button type="button"
                    class="match-occurrence-option"
                    role="radio"
                    [attr.aria-checked]="recurringTypeDraft === option.value"
                    [class.is-active]="recurringTypeDraft === option.value"
                    [disabled]="matchInfoSaving"
                    (click)="setRecurringTypeDraft(option.value)">
                    <i [class]="recurringTypeIconClass(option.icon)" aria-hidden="true"></i>
                    <span>
                      <strong>{{ option.labelKey | translate }}</strong>
                      <small>{{ option.descriptionKey | translate }}</small>
                    </span>
                  </button>
                }
              </div>
            </div>
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ 'common.cancel' | translate }}</button>

              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchOccurrence()">{{ 'common.save' | translate }}</button>

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'rules') {
          <div class="match-rules-editor">
            <div class="match-rules-intro">
              <div class="match-rules-intro-icon">
                <i [class]="'match.rulebook' | nogoshIcon" aria-hidden="true"></i>
              </div>
              <div>
                <p class="match-rules-intro-title mb-1">{{ 'events.rulebook' | translate }}</p>
                <p class="match-rules-intro-copy mb-0">{{ matchRulesIntroCopyKey() | translate }}</p>
              </div>
              @if (!rulesReadOnly && !rulesEnabledDraft) {
                <button type="button" class="btn btn-primary btn-sm px-3" (click)="enableRulebookDraft()">
                  <i [class]="('common.plus' | nogoshIcon) + ' mr-1'" aria-hidden="true"></i>
                  {{ 'events.enableRules' | translate }}
                </button>
              }
            </div>
            @if (!rulesReadOnly && rulesEnabledDraft) {
              <div class="match-rules-toggle-row">
                <button type="button" class="btn btn-outline-danger btn-sm px-3" (click)="disableRulebookDraft()">
                  <i [class]="('common.minus' | nogoshIcon) + ' mr-1'" aria-hidden="true"></i>
                  {{ 'events.disableRules' | translate }}
                </button>
              </div>
            }
            @if (rulesReadOnly || rulesEnabledDraft) {
            <div class="match-rule-card-list">
              @for (paragraph of ruleParagraphDrafts; track trackRuleParagraph($index)) {
                <article class="match-rule-card">
                  <div class="match-rule-card-header">
                    <span class="match-rule-number">{{ $index + 1 }}</span>
                    @if (!rulesReadOnly) {
                    <div class="match-rule-actions">
                      <button type="button" class="match-rule-icon-btn" (click)="addRuleParagraph($index)" [disabled]="matchInfoSaving" [attr.aria-label]="'common.add' | translate">
                        <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="match-rule-icon-btn" (click)="removeRuleParagraph($index)" [disabled]="matchInfoSaving" [attr.aria-label]="'common.remove' | translate">
                        <i [class]="'common.minus' | nogoshIcon" aria-hidden="true"></i>
                      </button>
                    </div>
                    }
                  </div>
                  @if (rulesReadOnly) {
                    <p class="match-rule-text mb-0">{{ paragraph }}</p>
                  } @else {
                  <textarea [(ngModel)]="ruleParagraphDrafts[$index]"
                    class="match-rule-textarea"
                    rows="4"
                    [name]="'matchRuleParagraph' + $index"
                    [attr.aria-label]="('events.rulebook' | translate) + ' ' + ($index + 1)">
                  </textarea>
                  }
                </article>
              }
            </div>
            }
            @if (rulesReadOnly && !rulesEnabledDraft) {
              <div class="match-rules-empty-state">
                {{ 'events.rulesReadOnlyEmptyCopy' | translate }}
              </div>
            }
            @if (matchInfoErrorMsg) {
              <div class="alert alert-danger mt-3" role="alert">{{ matchInfoErrorMsg }}</div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="matchInfoSaving" (click)="closeMatchInfoEditor()">{{ (rulesReadOnly ? 'common.close' : 'common.cancel') | translate }}</button>

              @if (shouldShowMatchRulesSave()) {
              <button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" type="button" class="btn btn-primary btn-sm px-3" [disabled]="matchInfoSaving" (click)="saveMatchRules()">{{ 'common.save' | translate }}</button>
              }

            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'playerManagement') {
          <event-player-management
            [eventId]="event.id"
            [embedded]="true"
            [initialEvent]="event" [initialPlayers]="event.playerEventInfos" [initialBlockedPlayers]="preparedBlockedPlayers"
            (playerListChanged)="handlePlayerManagementListChanged($event)"
            (playerSelected)="openRosterPlayer($event)"
            (closed)="closeMatchInfoEditor()">
          </event-player-management>
        }
	        @if (matchInfoEditorMode === 'addPlayers') {
	          <div>
              <h2>{{ 'events.managerFillTeam' | translate }}</h2>
              <div class="match-fill-summary"><div><strong>{{ countOfConfirmed }}/{{ event.maxPlayers }}</strong><span>{{ 'guestOwner.coming' | translate }}</span></div><div><strong>{{ countOfNotAnswered }}</strong><span>{{ 'events.notAnswered' | translate }}</span></div><div><strong>{{ countOfDeclined }}</strong><span>{{ 'guestOwner.notComing' | translate }}</span></div></div>
              <p>{{ 'catchUp.playersNeeded' | translate }}: <strong>{{ event.maxPlayers > countOfConfirmed ? event.maxPlayers - countOfConfirmed : 0 }}</strong></p>
              <section *ngIf="event.managerHome?.launchCampaign as campaign" class="match-home-notice mb-3">
                <h3>{{ 'events.managerLaunchCampaignTitle' | translate }}</h3>
                <p>{{ 'events.managerLaunchCampaignDescription' | translate }}</p>
                <p *ngIf="recruitmentSent" role="status">{{ 'events.managerLaunchCampaignNextSteps' | translate }}</p>
                <p *ngIf="campaign.status === 'SENT'">{{ 'catchUp.campaignRecipients' | translate }}: {{ campaign.recipientCount || 0 }} · {{ 'events.joinPending' | translate }}: {{ campaign.pendingCandidateCount || 0 }}</p>
                <p *ngIf="campaign.status !== 'AVAILABLE' && campaign.status !== 'SENT'">{{ campaignUnavailableKey(campaign) | translate }}</p>
                <p *ngIf="recruitmentError" role="alert" class="text-danger">{{ recruitmentError }}</p>
                <button *ngIf="campaign.status === 'AVAILABLE'" type="button" class="btn btn-primary" [disabled]="recruitmentSaving" (click)="confirmRecruitment()">{{ 'events.managerLaunchCampaignAction' | translate }} · {{ campaign.eligibleRecipientCount || 0 }}</button>
              </section>
              <button class="btn btn-primary mb-3" (click)="openNotificationsPage()">{{ 'events.managerInvitePlayers' | translate }} · {{ invitationEligibleCount(event) }}</button>
              <button class="btn btn-outline-primary mb-3 ml-2" (click)="openOverviewRoster()">{{ 'events.players' | translate }}</button>

	            <div class="add-players-screen-options subscreen-menu-options">
	              @if (!canAddHistoryAttendees(event)) {
	              <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openAddPlayersPage('inviteNewUsers')">
	                <i [class]="'match.inviteLink' | nogoshIcon" aria-hidden="true"></i>
	                <span class="match-settings-option-copy">
                    <span>{{ 'guestOwner.share.title' | translate }}</span>
                    <small>{{ 'notifications.inviteLinkMenuDescription' | translate }}</small>
                  </span>
	              </button>
	              <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openAddPlayersPage('inviteViaEmail')">
	                <i [class]="'match.inviteEmail' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.inviteViaEmail' | translate }}</span>
                  <small>{{ 'notifications.inviteViaEmailMenuDescription' | translate }}</small>
                </span>
              </button>
	              <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openAddPlayersPage('directInvite')">
	                <i [class]="'match.inviteDirect' | nogoshIcon" aria-hidden="true"></i>
	                <span class="match-settings-option-copy">
                    <span>{{ 'events.directInviteTitle' | translate }}</span>
                    <small>{{ 'events.directInviteMenuDescription' | translate }}</small>
                  </span>
	              </button>
	              }
	              <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openAddPlayersPage(canAddHistoryAttendees(event) ? 'footballerFriends' : 'footballNetwork')">
	                <i [class]="'match.inviteFriends' | nogoshIcon" aria-hidden="true"></i>
	                <span class="match-settings-option-copy">
                    <span>{{ (canAddHistoryAttendees(event) ? 'events.inviteFootballerFriendsTitle' : 'events.footballNetworkTitle') | translate }}</span>
                    <small>{{ (canAddHistoryAttendees(event) ? 'events.addHistoryFootballerFriendsMenuDescription' : 'events.footballNetworkDescription') | translate }}</small>
                  </span>
	              </button>
	              <button type="button" class="add-players-screen-option subscreen-menu-option" (click)="openAddPlayersPage('guestPlayers')">
	                <i [class]="'match.inviteGuest' | nogoshIcon" aria-hidden="true"></i>
	                <span class="match-settings-option-copy">
                    <span>{{ 'notifications.guestPlayers' | translate }}</span>
                    <small>{{ 'notifications.guestPlayersMenuDescription' | translate }}</small>
                  </span>
	              </button>
            </div>
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" (click)="closeMatchInfoEditor()">{{ 'common.close' | translate }}</button>


            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'inviteNewUsers') {
          <div class="add-players-detail-screen invite-link-screen">
            <div class="invite-link-card">
              <div class="invite-link-card-icon">
                <i [class]="'common.share' | nogoshIcon" aria-hidden="true"></i>
              </div>
              <h5 class="invite-link-card-title">{{ 'guestOwner.share.copy' | translate }}</h5>
              @if (newUserInviteLinkLoading) {
                <app-loading-state titleKey="notifications.inviteLinkLoading" [compact]="true"></app-loading-state>
              }
              @if (newUserInviteLinkErrorMsg) {
                <div class="alert alert-danger" role="alert">{{ newUserInviteLinkErrorMsg }}</div>
              }
              @if (newUserInviteLinkUrl) {
                <p #inviteMessage class="invite-link-message">{{ 'notifications.shareInvite' | translate:{matchName: event.name} }} <a [href]="newUserInviteLinkUrl">{{newUserInviteLinkUrl}}</a></p>
              }
              <div appActionBar class="match-info-edit-actions invite-link-actions">
                <button type="button" class="btn btn-primary btn-sm px-3 text-white" [disabled]="newUserInviteLinkLoading || !newUserInviteLinkUrl" (click)="copyNogoshInviteMessage()">{{ 'common.copy' | translate }}</button>
                <button type="button" class="btn btn-secondary btn-sm px-3 text-white" [disabled]="newUserInviteLinkLoading" (click)="closeAddPlayersPage()">{{ 'common.close' | translate }}</button>
              </div>
              @if (newUserInviteLinkCopiedMsg) {
                <div class="invite-link-feedback" role="status">
                  <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
                  <span>{{ newUserInviteLinkCopiedMsg }}</span>
                </div>
              }
            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'inviteViaEmail') {
          <div class="add-players-detail-screen invite-email-screen">
            <p class="text-nogosh-grey3 mb-4">{{ 'notifications.inviteViaEmailHelp' | translate:{max: maxEmailInvites} }}</p>
            @if (emailInviteErrorMsg) {
              <div class="alert alert-danger" role="alert">{{ emailInviteErrorMsg }}</div>
            }
            @if (emailInviteSuccessMsg) {
              <div class="alert alert-success" role="status">{{ emailInviteSuccessMsg }}</div>
            }
            <div class="form-group">
              <label class="mb-1" for="emailInviteText">{{ 'notifications.emails' | translate }}</label>
              <textarea [(ngModel)]="emailInviteText"
                class="form-control invite-email-textarea"
                id="emailInviteText"
                name="emailInviteText"
                rows="7"
                [placeholder]="'notifications.inviteViaEmailPlaceholder' | translate"
                [disabled]="emailInviteInProgress"></textarea>
              <div class="text-nogosh-grey3 text-sm mt-2">{{ 'notifications.inviteViaEmailLimit' | translate:{max: maxEmailInvites} }}</div>
            </div>
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" [disabled]="emailInviteInProgress" (click)="closeAddPlayersPage()">{{ 'common.close' | translate }}</button>
              <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="emailInviteInProgress" (click)="sendEmailInvites()">
                @if (emailInviteInProgress) {
                  <app-delayed-indicator></app-delayed-indicator>
                }
                {{ 'notifications.sendEmailInvites' | translate }}
              </button>
            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'directInvite') {
          <div class="add-players-detail-screen">
            <p class="text-nogosh-grey3 mb-4">{{ 'events.directInviteHint' | translate }}</p>
            @if (directInviteErrorMsg) {
              <div class="alert alert-danger" role="alert">{{ directInviteErrorMsg }}</div>
            }
            @if (directInviteSuccessMsg) {
              <div class="alert alert-success" role="status">{{ directInviteSuccessMsg }}</div>
            }
            <div class="form-group">
              <label class="mb-0" for="directInviteEmail">{{ 'common.email' | translate }}</label>
              <input [(ngModel)]="directInviteEmail" type="email" class="form-control" id="directInviteEmail" name="directInviteEmail" [placeholder]="'events.directInviteEmailPlaceholder' | translate" autocomplete="off">
            </div>
            <div class="form-group">
              <label class="mb-0" for="directInviteNickName">{{ 'common.nickname' | translate }}</label>
              <input [(ngModel)]="directInviteNickName" type="text" class="form-control" id="directInviteNickName" name="directInviteNickName" [placeholder]="'events.directInviteNickPlaceholder' | translate" autocomplete="off">
            </div>
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="directInviteInProgress" (click)="sendDirectInvite()">
                @if (directInviteInProgress) {
                  <app-delayed-indicator></app-delayed-indicator>
                }
                {{ 'players.invite' | translate }}
              </button>
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" [disabled]="directInviteInProgress" (click)="closeAddPlayersPage()">{{ 'common.close' | translate }}</button>
            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'footballNetwork' || matchInfoEditorMode === 'footballerFriends' || matchInfoEditorMode === 'openProfiles' || matchInfoEditorMode === 'nogoshPlayers') {
          <div class="add-players-detail-screen">
	            <p class="text-nogosh-grey3 mb-4">{{ (canAddHistoryAttendees(event) ? 'events.addHistoryFootballerFriendsHint' : currentNogoshInviteHintKey()) | translate:{city: currentPlayer.city} }}</p>
            @if (matchInfoEditorMode === 'footballNetwork') {
              <div class="football-network-tabs" role="tablist">
                <button type="button" role="tab" [class.is-active]="footballNetworkSource === 'friends'" (click)="selectFootballNetworkSource('friends')">{{ 'events.footballNetworkFriendsTab' | translate }}</button>
                <button type="button" role="tab" [class.is-active]="footballNetworkSource === 'references'" (click)="selectFootballNetworkSource('references')">{{ 'events.footballNetworkReferencesTab' | translate }}</button>
                <button type="button" role="tab" [class.is-active]="footballNetworkSource === 'openProfiles'" (click)="selectFootballNetworkSource('openProfiles')">{{ 'events.footballNetworkOpenProfilesTab' | translate }}</button>
              </div>
            }
            @if ((matchInfoEditorMode === 'openProfiles' || (matchInfoEditorMode === 'footballNetwork' && footballNetworkSource === 'openProfiles')) && !canSearchNogoshPlayersByCity()) {
              <div class="alert alert-info" role="status">
                {{ 'events.addNogoshPlayersCityRequired' | translate }}
                <a [routerLink]="['/player-detail', false]" class="alert-link">{{ 'events.updateProfileCity' | translate }}</a>
              </div>
            }
            @if (nogoshPlayersSearchErrorMsg) {
              <div class="alert alert-danger" role="alert">{{ nogoshPlayersSearchErrorMsg }}</div>
            }
            @if (canSearchCurrentNogoshInviteSource()) {
              <div class="form-group">
                <label class="mb-1" for="eventPlayersPageSearch">{{ 'events.selectPlayersToInvite' | translate }}</label>
                <div class="invite-player-search">
                  <div class="invite-player-search-box">
                    <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
                    <input [(ngModel)]="inviteCandidateSearchText"
                      [placeholder]="currentNogoshInvitePlaceholderKey() | translate"
                      name="inviteCandidateSearchText"
                      id="eventPlayersPageSearch"
                      autocomplete="off"
                      (keyup.enter)="searchInviteCandidates()">
                    @if (inviteCandidateSearchText) {
                      <button type="button"
                        class="invite-player-search-clear"
                        [attr.aria-label]="'common.clear' | translate"
                        (click)="clearInviteCandidateSearch()">
                        <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                      </button>
                    }
                  </div>
                  <button type="button" class="invite-player-search-action" [disabled]="inviteCandidateLoading || (!inviteCandidateSearchText.trim() && matchInfoEditorMode !== 'footballNetwork')" (click)="searchInviteCandidates()">
                    @if (inviteCandidateLoading) {
                      <app-delayed-indicator></app-delayed-indicator>
                    } @else {
                      <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
                    }
                    <span>{{ 'events.invitePlayersSearch' | translate }}</span>
                  </button>
                </div>
              </div>
            }
            @if (inviteCandidateLoading === true) {
              <app-loading-state titleKey="events.invitePlayersLoading" [compact]="true"></app-loading-state>
            }
            @if (typeaheadPlayerNoResults === true && !inviteCandidateLoading) {
              <div class="invite-player-empty">{{ 'events.invitePlayersNoResults' | translate }}</div>
            }
            @if (nogoshPlayersAddSuccessMsg) {
              <div class="alert alert-success" role="status">{{ nogoshPlayersAddSuccessMsg }}</div>
            }
            @if (inviteCandidatePlayers.length > 0) {
              <div class="invite-player-list mb-4">
                @for (player of inviteCandidatePlayers; track player.id) {
                  <button type="button"
                    class="invite-player-row"
                    [class.is-selected]="isSelectedInviteCandidate(player)"
                    (click)="toggleInviteCandidate(player)">
                    <span class="invite-player-avatar">
                      @if (player.avatar) {
                        <img [src]="player.avatar"
                          onerror="this.src='../../assets/images/user1.jpg'"
                          [alt]="'accessibility.userProfileImage' | translate">
                      } @else {
                        <span class="avatar-team-fallback" [ngClass]="playerAvatarTone(player)" aria-hidden="true">{{playerInitials(player)}}</span>
                      }
                    </span>
                    <span class="invite-player-main">
                      <span class="invite-player-name">{{ player.nickName || player.name }}</span>
                      @if (player.name && player.nickName && player.name !== player.nickName) {
                        <span class="invite-player-meta">{{ player.name }}</span>
                      }
                      @if (matchInfoEditorMode === 'footballNetwork' && footballNetworkSource === 'references' && player.networkReferences?.length) {
                        <span class="invite-player-meta">{{ 'events.footballNetworkVia' | translate }} {{ footballNetworkReferenceNames(player) }}</span>
                      }
                    </span>
                    <span class="invite-player-action">
	                      @if (isSelectedInviteCandidate(player)) {
	                        <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
	                      } @else {
	                        <i [class]="canAddHistoryAttendees(event) ? ('common.plus' | nogoshIcon) : ('match.inviteDirect' | nogoshIcon)" aria-hidden="true"></i>
	                      }
                    </span>
                  </button>
                }
              </div>
            }
            @if (selectedPlayers.length > 0) {
              <div class="invite-selected-summary mb-4">
                <div class="invite-selected-title">{{ 'events.invitePlayersSelectedCount' | translate:{count: selectedPlayers.length} }}</div>
                <div class="invite-selected-list">
                  @for (player of selectedPlayers; track player.id) {
                    <button type="button" class="invite-selected-chip" (click)="removePlayerFromInviteList(player)">
                      <span>{{ player.nickName || player.name }}</span>
                      <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                      </button>
                  }
                </div>
              </div>
            }
            @if (addedNogoshPlayers.length > 0) {
              <div class="mb-4">
                <h6>{{ 'events.addedPlayers' | translate }}</h6>
                @for (player of addedNogoshPlayers; track player) {
                  <div class="players-list py-2 border-bottom border-bottom-not-last">
                    <div class="row player-row align-items-center">
                      <div class="col-auto pr-2 pr-sm-3">
                        @if (player.avatar) {
                          <img [src]="player.avatar"
                            onerror="this.src='../../assets/images/user1.jpg'"
                            class="rounded-circle border"
                            style="width: 40px; height: 40px"
                            [alt]="'accessibility.userProfileImage' | translate">
                        } @else {
                          <span class="rounded-circle border player-avatar-fallback avatar-team-fallback"
                            [ngClass]="playerAvatarTone(player)" aria-hidden="true">{{playerInitials(player)}}</span>
                        }
                      </div>
                      <div class="col pl-0 text-sm font-weight-500 players-nickname d-flex flex-column justify-content-center line-height-10" title="{{player.nickName}}">
                        {{player.nickName}}
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="closeAddPlayersPage()">{{ 'common.close' | translate }}</button>
              @if (canSearchCurrentNogoshInviteSource()) {
	                <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="selectedPlayers.length === 0 || loadingPlayersList" (click)="addSelectedPlayersFromPage()">
	                  @if (loadingPlayersList) {
	                    <app-delayed-indicator></app-delayed-indicator>
	                  }
	                  {{ (canAddHistoryAttendees(event) ? 'common.add' : 'players.invite') | translate }}
	                </button>
	              }
            </div>
          </div>
        }
	        @if (matchInfoEditorMode === 'guestPlayers') {
	          <div class="add-players-detail-screen">
            @if (guestErrorMsg) {
              <div class="text-danger mb-3">{{guestErrorMsg}}</div>
            }
            @if (!selectedGuestForEdit) {
              <p class="text-nogosh-grey3 mb-4">{{ 'guests.screenDescription' | translate }}</p>
              <div class="add-guest-inline mb-4">
                <input [(ngModel)]="guestForm.name" type="text" class="form-control" id="guestNamePage" name="guestNamePage" [placeholder]="'guests.namePlaceholder' | translate" autocomplete="off">
                <button type="button" class="btn btn-primary px-4" [disabled]="guestActionInProgress || !(guestForm.name || '').trim()" (click)="createGuestOnEvent()">{{ 'guests.addManagedPlayer' | translate }}</button>
              </div>
              <div>
                @if (guestPlayers.length === 0) {
                  <div class="text-nogosh-grey3 text-sm">{{ 'guests.empty' | translate }}</div>
                }
                @if (guestPlayers.length > 0) {
                  <div class="players-list-wrapper player-section-card card mb-4">
                    <div class="card-body px-3 py-0">
                    @for (guest of guestPlayers; track guest.id) {
                      <button type="button"
                        class="players-list py-2 border-bottom border-bottom-not-last cursor-pointer guest-player-row"
                        [class.is-selected]="isGuestAlreadyOnEvent(guest)"
                        (click)="openGuestDetail(guest)">
                        <div class="row player-row align-items-center">
                          <div class="col-auto pr-2 pr-sm-3">
                            <div class="avatar-team player-team-avatar">
                              @if (guest.avatar) {
                                <img [src]="guest.avatar"
                                  onerror="this.src='../../assets/images/user1.jpg'"
                                  class="rounded-circle border"
                                  style="width: 40px; height: 40px"
                                  [alt]="'accessibility.userProfileImage' | translate">
                              } @else {
                                <span class="rounded-circle border player-avatar-fallback avatar-team-fallback"
                                  [ngClass]="playerAvatarTone(guest)" aria-hidden="true">{{playerInitials(guest)}}</span>
                              }
                            </div>
                          </div>
                          <div class="col pl-0 text-sm font-weight-500 players-nickname d-flex flex-column justify-content-center line-height-10"
                            title="{{ getGuestDisplayName(guest) }}">
                            {{ getGuestDisplayName(guest) }}
                            <span class="text-nogosh-grey3 text-sm mt-1">{{ 'guests.managedPlayer' | translate }}</span>
                          </div>
                          <div class="col-auto align-items-center">
                            <i [class]="('match.chevronForward' | nogoshIcon) + ' h3 m-0'"></i>
                          </div>
                        </div>
                      </button>
                    }
                    </div>
                  </div>
                }
              </div>
            } @else {
              <section class="guest-player-detail">
                <player-detail
                  [embedded]="true"
                  [embeddedEvent]="event"
                  [embeddedPlayerEventInfo]="selectedGuestPlayerEventInfo()"
                  (removedFromMatch)="onEmbeddedPlayerRemoved()">
                </player-detail>
                <div class="guest-player-detail-actions">
                  <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="guestActionInProgress" (click)="dialogDeactivateGuest(selectedGuestForEdit)">
                    {{ 'guests.deactivateAction' | translate }}
                  </button>
                </div>
              </section>
              }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="closeAddPlayersPage()">{{ 'common.close' | translate }}</button>
            </div>
            <app-dialog [(visible)]="showDeactivateGuestDialog">
              <div class="modal-header">
                <h5 class="mb-0">{{ 'guests.deactivateTitle' | translate }}</h5>
              </div>
              <div class="modal-body">
                <p>{{ 'guests.deactivateDescription' | translate }}</p>
                @if (guestForDeactivate) {
                  <p>{{ 'guests.managedPlayer' | translate }}: <b>{{getGuestDisplayName(guestForDeactivate)}}</b></p>
                }
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="guestActionInProgress" (click)="showDeactivateGuestDialog = false;guestForDeactivate = null">{{ 'common.cancel' | translate }}</button>
                <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="guestActionInProgress" (click)="deactivateGuest()">{{ 'guests.deactivateAction' | translate }}</button>
              </div>
	            </app-dialog>
	          </div>
	        }
	        @if (matchInfoEditorMode === 'result') {
		          <div class="add-players-detail-screen event-result-screen">
		            @if (resultLoading) {
		              <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
		            }
	            @for (game of resultGames; track game.roundNumber; let gameIndex = $index) {
	              <section class="event-result-game event-result-screen-game">
	                <div class="event-result-game-header">
	                  <h6 class="mb-0">{{ resultRoundLabel(game) }}</h6>
	                  @if (resultGames.length > 1) {
	                    <button type="button" class="event-result-remove" (click)="removeResultGame(gameIndex)" [disabled]="resultSaving" [attr.aria-label]="'common.remove' | translate">
	                      <i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i>
	                    </button>
	                  }
	                </div>
		                <div class="event-result-score-row">
		                  <div class="event-result-score-field">
		                    <input type="number" min="0" class="form-control text-center" name="resultScreenWhiteScore{{gameIndex}}" [(ngModel)]="game.whiteScore" [disabled]="resultSaving">
	                  </div>
	                  <div class="event-result-score-separator">:</div>
	                  <div class="event-result-score-field">
		                    <input type="number" min="0" class="form-control text-center" name="resultScreenBlackScore{{gameIndex}}" [(ngModel)]="game.blackScore" [disabled]="resultSaving">
		                  </div>
		                </div>
		                <div class="event-result-team-shirts" aria-hidden="true">
		                  <i [class]="('player.team' | nogoshIcon) + ' event-history-white-shirt'"></i>
		                  <i [class]="('player.team' | nogoshIcon) + ' event-history-black-shirt'"></i>
		                </div>
		                <div class="event-result-round-teams event-result-screen-teams">
		                  <div class="event-result-round-team">
	                    @for (playerEventInfo of gameTeamPlayers(resultEvent, game, playerEventInfoJersey.WHITE); track playerEventInfo.id) {
	                      <div class="event-result-round-player event-result-screen-player">
	                        <button type="button" class="event-result-round-player-name event-result-screen-player-name" (click)="toggleGamePlayerJersey(game, playerEventInfo.player.id)" [disabled]="resultSaving">
	                          @if (playerEventInfo.player.avatar) {
	                            <img [src]="playerEventInfo.player.avatar" [alt]="getPlayerDisplayName(playerEventInfo)" onerror="this.style.display='none'">
	                          } @else {
	                            <span>{{getPlayerInitials(playerEventInfo)}}</span>
	                          }
	                          <b>{{getPlayerDisplayName(playerEventInfo)}}</b>
	                        </button>
	                        <button type="button" class="event-result-round-player-remove" (click)="removeGamePlayer(game, playerEventInfo.player.id)" [disabled]="resultSaving" [attr.aria-label]="'common.remove' | translate">
	                          <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
	                        </button>
	                      </div>
	                    }
	                  </div>
	                  <div class="event-result-round-team">
	                    @for (playerEventInfo of gameTeamPlayers(resultEvent, game, playerEventInfoJersey.BLACK); track playerEventInfo.id) {
	                      <div class="event-result-round-player event-result-screen-player">
	                        <button type="button" class="event-result-round-player-name event-result-screen-player-name" (click)="toggleGamePlayerJersey(game, playerEventInfo.player.id)" [disabled]="resultSaving">
	                          @if (playerEventInfo.player.avatar) {
	                            <img [src]="playerEventInfo.player.avatar" [alt]="getPlayerDisplayName(playerEventInfo)" onerror="this.style.display='none'">
	                          } @else {
	                            <span>{{getPlayerInitials(playerEventInfo)}}</span>
	                          }
	                          <b>{{getPlayerDisplayName(playerEventInfo)}}</b>
	                        </button>
	                        <button type="button" class="event-result-round-player-remove" (click)="removeGamePlayer(game, playerEventInfo.player.id)" [disabled]="resultSaving" [attr.aria-label]="'common.remove' | translate">
	                          <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
	                        </button>
	                      </div>
	                    }
	                  </div>
	                </div>
	                @if (gameAvailablePlayers(resultEvent, game).length > 0) {
	                  <div class="event-result-bench">
	                    @for (playerEventInfo of gameAvailablePlayers(resultEvent, game); track playerEventInfo.id) {
                        <div class="event-result-bench-player">
                          <span>{{getPlayerDisplayName(playerEventInfo)}}</span>
                          <div class="event-result-bench-actions">
                            <button type="button" class="event-result-bench-team" (click)="setGamePlayerJersey(game, playerEventInfo.player.id, playerEventInfoJersey.WHITE)" [disabled]="resultSaving" [attr.aria-label]="('events.whiteTeam' | translate) + ': ' + getPlayerDisplayName(playerEventInfo)">
                              <i [class]="('player.team' | nogoshIcon) + ' event-history-white-shirt'" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="event-result-bench-team" (click)="setGamePlayerJersey(game, playerEventInfo.player.id, playerEventInfoJersey.BLACK)" [disabled]="resultSaving" [attr.aria-label]="('events.blackTeam' | translate) + ': ' + getPlayerDisplayName(playerEventInfo)">
                              <i [class]="('player.team' | nogoshIcon) + ' event-history-black-shirt'" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
	                    }
	                  </div>
	                }
	              </section>
	            }
	            <div class="event-result-add">
	              <button type="button" class="btn btn-outline-primary btn-sm" (click)="addResultGame()" [disabled]="resultSaving || resultLoading">
	                <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
	                {{ 'events.addGameRound' | translate }}
	              </button>
	            </div>
	            @if (resultErrorMsg) {
	              <p class="alert alert-danger py-2 mt-3 mb-0" role="alert">{{ resultErrorMsg }}</p>
	            }
              @if (resultValidationMessage()) {
                <p class="alert alert-warning py-2 mt-3 mb-0 text-center" role="status">{{ resultValidationMessage() }}</p>
              }
	            <div appActionBar class="match-info-edit-actions event-result-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3" (click)="closeResultDialog()" [disabled]="resultSaving">{{ 'common.cancel' | translate }}</button>

	              <button appSaveAction [saved]="matchInfoSaved" [saving]="resultSaving" type="button" class="btn btn-primary btn-sm px-3" (click)="saveResult()" [disabled]="resultSaving || resultLoading || !canSaveResult()">{{ 'common.save' | translate }}</button>

	            </div>
	          </div>
	        }
	        @if (matchInfoEditorMode === 'playerDetail' && selectedPlayerDetailEventInfo) {
	          <div class="match-player-detail-screen">
            <player-detail
              [embedded]="true"
              [embeddedEvent]="event"
              [embeddedPlayerEventInfo]="selectedPlayerDetailEventInfo"
              (removedFromMatch)="onEmbeddedPlayerRemoved()">
            </player-detail>
          </div>
        }
        @if (matchInfoEditorMode === 'notifications') {
          <div class="add-players-detail-screen">
            @if (showNotificationsSent) {
              <div class="alert alert-success text-center" role="status">{{ 'notifications.sentGroup' | translate:{group: notificationsSentGroupLabel} }}</div>
            }
            @if (showNotificationLimitReached || standardInvitationsExhausted(event)) {
              <div class="alert alert-info text-center" role="status">{{ 'notifications.invitationLimitReached' | translate }}</div>
            }
            <p class="text-nogosh-grey3 text-center">
              @if (event.nextOccurrenceTimestamp) {
                {{ 'notifications.inviteForDay' | translate:{day: (event.nextOccurrenceTimestamp | localizedDate:'EEEE')} }}
              } @else {
                {{ 'events.selectPlayersToInvite' | translate }}
              }
            </p>
            <div class="add-players-screen-options subscreen-menu-options">
              <button type="button" class="add-players-screen-option subscreen-menu-option" [disabled]="event.sendingNotificationsInProgress || invitationEligibleCount(event, teamMemberType.FIRST_TEAM) === 0" (click)="dialogNotifyPlayers(event, teamMemberType.FIRST_TEAM)">
                <i [class]="'match.maxPlayers' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.firstTeam' | translate }}</span>
                  <small>{{ 'notifications.firstTeamDescription' | translate }}</small>
                </span>
              </button>
              <button type="button" class="add-players-screen-option subscreen-menu-option" [disabled]="event.sendingNotificationsInProgress || invitationEligibleCount(event, teamMemberType.RESERVE) === 0" (click)="dialogNotifyPlayers(event, teamMemberType.RESERVE)">
                <i [class]="'match.notify.reserve' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.reserves' | translate }}</span>
                  <small>{{ 'notifications.reserveDescription' | translate }}</small>
                </span>
              </button>
              <button type="button" class="add-players-screen-option subscreen-menu-option" [disabled]="event.sendingNotificationsInProgress || reminderEligibleCount(event) === 0" (click)="dialogNotifyPlayersWithNoResponse(event)">
                <i [class]="'match.notify.noResponse' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.remindInvited' | translate }}</span>
                  <small>{{ 'notifications.remindInvitedDescription' | translate }}</small>
                </span>
              </button>
              <button type="button" class="add-players-screen-option subscreen-menu-option" [disabled]="event.sendingNotificationsInProgress || invitationEligibleCount(event) === 0" (click)="dialogNotifyPlayers(event, null)">
                <i [class]="'match.notifications' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.allPlayers' | translate }}</span>
                  <small>{{ 'notifications.allPlayersDescription' | translate }}</small>
                </span>
              </button>
              <button type="button" class="add-players-screen-option subscreen-menu-option" [disabled]="event.sendingNotificationsInProgress" (click)="dialogNotifyTeammateOpenProfiles(event)">
                <i [class]="'match.notify.sosContacts' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.sosContacts' | translate }}</span>
                  <small>{{ 'notifications.sosContactsDescription' | translate }}</small>
                </span>
              </button>
              <button type="button" class="add-players-screen-option subscreen-menu-option" [disabled]="event.sendingNotificationsInProgress" (click)="dialogNotifyAllOpenProfiles(event)">
                <i [class]="'match.notify.sosOther' | nogoshIcon" aria-hidden="true"></i>
                <span class="match-settings-option-copy">
                  <span>{{ 'notifications.sosOther' | translate }}</span>
                  <small>{{ 'notifications.sosOtherDescription' | translate }}</small>
                </span>
              </button>
            </div>
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="closeMatchInfoEditor()">{{ 'common.close' | translate }}</button>


            </div>
            <app-dialog [(visible)]="showNotifyConfirmDialog" [closable]="false" class="app-dialog--confirm">
              <div class="modal-header">
                <h5 class="mb-0"><i [class]="('common.warning' | nogoshIcon) + ' text-warning'" aria-hidden="true"></i> {{ 'notifications.inviteConfirmTitle' | translate }}</h5>
              </div>
              <div class="modal-body">
                <p>{{ 'notifications.inviteConfirmMessage' | translate:{group: notifyConfirmGroupLabel} }}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showNotifyConfirmDialog = false">{{ 'common.no' | translate }}</button>
                <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="confirmNotifyPlayers()">{{ 'common.yes' | translate }}</button>
              </div>
            </app-dialog>
            <app-dialog [(visible)]="showNotifyAllOpenProfiles" [closable]="false" class="app-dialog--confirm">
              <div class="modal-header">
                <h5 class="mb-0">{{ 'notifications.sosTitle' | translate }}</h5>
              </div>
              <div class="modal-body">
                <p>{{ 'notifications.sosRandom' | translate }}</p>
                <p>{{ 'notifications.sosHelp' | translate }}</p>
                <p>{{ 'notifications.sosOnce' | translate }}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showNotifyAllOpenProfiles = false">{{ 'common.cancel' | translate }}</button>
                <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="notifyAllOpenProfiles(); showNotifyAllOpenProfiles = false">{{ 'notifications.openAndSendSos' | translate }}</button>
              </div>
            </app-dialog>
            <app-dialog [(visible)]="showNotifyTeammateOpenProfiles" [closable]="false" class="app-dialog--confirm">
              <div class="modal-header">
                <h5 class="mb-0"><i [class]="('common.warning' | nogoshIcon) + ' text-warning'"></i> {{ 'notifications.sosTeammatesTitle' | translate }}</h5>
              </div>
              <div class="modal-body">
                <p>{{ 'notifications.sosTeammates' | translate }}</p>
                <p>{{ 'notifications.sosHelp' | translate }}</p>
                <p>{{ 'notifications.sosOnce' | translate }}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showNotifyTeammateOpenProfiles = false">{{ 'common.cancel' | translate }}</button>
                <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="notifyTeammateOpenProfiles(); showNotifyTeammateOpenProfiles = false">{{ 'notifications.openAndSendSos' | translate }}</button>
              </div>
            </app-dialog>
          </div>
        }
        @if (matchInfoEditorMode === 'stats') {
          <div class="add-players-detail-screen">
            <div class="stats-title-with-info stats-info-action-row mb-3">
              <button type="button" class="stats-info-button" (click)="showStatsScoreInfoDialog = true" [attr.aria-label]="'stats.formulaInfo' | translate" data-testid="match-stats-score-info">
                <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
              </button>
            </div>
            <app-dialog presentation="sheet" [(visible)]="showStatsScoreInfoDialog" [closable]="false" class="app-dialog--standard">
              <div class="modal-header">
                <h4 class="modal-title pull-left">{{ statsInfoTitleKey() | translate }}</h4>
              </div>
              <div class="modal-body stats-formula-dialog" data-testid="match-stats-score-info-dialog">
                <h5>{{ 'stats.infoIdeaLabel' | translate }}</h5>
                <p>{{ statsInfoDescriptionKey() | translate }}</p>
                <p>{{ statsInfoMeaningKey() | translate }}</p>
                @if (showPraviFudbaleriAllTimeEasterEgg()) {
                  <p class="stats-easter-egg">{{ 'stats.praviFudbaleriAllTimeEasterEgg' | translate }}</p>
                }
                <h5>{{ 'stats.infoAlgorithmLabel' | translate }}</h5>
                <p>{{ statsInfoAlgorithmKey() | translate }}</p>
                <h5>{{ 'stats.infoFormulaLabel' | translate }}</h5>
                <p>{{ statsInfoFormulaKey() | translate }}</p>
                <p>{{ statsInfoFormulaDetailKey() | translate }}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showStatsScoreInfoDialog = false">{{ 'common.close' | translate }}</button>
              </div>
            </app-dialog>
            @if (inlineStatsErrorMsg) {
              <div class="alert alert-danger" role="alert">{{ inlineStatsErrorMsg }}</div>
            }
	            @if (inlineStatsLoading) {
	              <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
	            }
            @if (inlineEventStats && !inlineStatsLoading) {
              @if (hasStatsSeasons(inlineEventStats)) {
              <div class="stats-panel">
                <div class="stats-panel-tabs">
                  <div class="stats-metric-tabs" role="tablist" [attr.aria-label]="'stats.title' | translate">
                    <button type="button" class="stats-metric-tab" [class.is-active]="activeStatsMetric === 'playerScore'" (click)="setStatsMetric('playerScore')" role="tab" [attr.aria-selected]="activeStatsMetric === 'playerScore'">
                      {{ 'stats.playerScore' | translate }}
                    </button>
                    <button type="button" class="stats-metric-tab" [class.is-active]="activeStatsMetric === 'teamBoost'" (click)="setStatsMetric('teamBoost')" role="tab" [attr.aria-selected]="activeStatsMetric === 'teamBoost'">
                      {{ 'stats.teamBoost' | translate }}
                    </button>
                  </div>
                  <div class="stats-period-tabs" role="tablist" [attr.aria-label]="'stats.period' | translate">
                    <button type="button" class="stats-period-tab" [class.is-active]="activeStatsPeriod === 'season'" (click)="setStatsPeriod('season')" role="tab" [attr.aria-selected]="activeStatsPeriod === 'season'">
                      {{ 'stats.thisSeason' | translate }}
                    </button>
                    <button type="button" class="stats-period-tab" [class.is-active]="activeStatsPeriod === 'allTime'" (click)="setStatsPeriod('allTime')" role="tab" [attr.aria-selected]="activeStatsPeriod === 'allTime'">
                      {{ 'stats.allTime' | translate }}
                    </button>
                  </div>
                </div>
                <div class="stats-season-list">
                @for (seasonStats of visibleStatsSeasons(inlineEventStats); track seasonStats; let seasonIndex = $index) {
                  @if (hasSeasonRankedStats(seasonStats)) {
                    <details class="stats-season" [open]="isInlineStatsSeasonOpen(seasonIndex)" (toggle)="setInlineStatsSeasonOpen(seasonIndex, $event)">
                      <summary class="stats-season-header">
                        <span class="stats-season-heading">
                          <span id="inline-stats-season-{{seasonIndex}}" class="stats-season-title">{{inlineEventStats.event.name}}</span>
                          <span class="stats-season-dates">
                            @if (seasonStatsPeriod(seasonStats) === 'allTime') {
                              <span>{{ 'stats.allTime' | translate }}</span>
                            } @else {
                              <span>{{seasonStats.seasonStart | localizedDate:'MMM yyyy'}}</span>
                              <span>{{seasonStats.seasonEnd | localizedDate:'MMM yyyy'}}</span>
                            }
                          </span>
                        </span>
                        @if (topSeasonStat(seasonStats); as seasonLeader) {
                          <span class="stats-season-leader">
                            <i [class]="('match.rating' | nogoshIcon) + ' stats-season-leader-label'" aria-hidden="true"></i>
                            <span>{{seasonLeader.playerName}}</span>
                          </span>
                          <strong class="stats-season-score">{{statsMetricScore(seasonLeader) | number:'1.2-2'}}</strong>
                        }
                        <i [class]="('common.chevronDown' | nogoshIcon) + ' stats-season-toggle'" aria-hidden="true"></i>
                      </summary>
                      <div class="table-responsive stats-table-wrap">
                        <table class="table table-striped table-sm table-hover stats-table">
                          <caption>{{inlineEventStats.event.name}} {{statsSeasonCaption(seasonStats)}}</caption>
                          <thead>
                            <tr>
                              <th scope="col">{{ 'players.player' | translate }}</th>
                              <th scope="col">
                                {{ 'events.score' | translate }}
                              </th>
                              <th scope="col">{{ 'stats.wins' | translate }}</th>
                              <th scope="col">{{ 'stats.losses' | translate }}</th>
                              <th scope="col">{{ 'stats.draws' | translate }}</th>
                              <th scope="col">{{ 'stats.teamScored' | translate }}</th>
                              <th scope="col">{{ 'stats.teamConceded' | translate }}</th>
                              <th scope="col">{{ 'stats.playedWhites' | translate }}</th>
                              <th scope="col">{{ 'stats.playedBlacks' | translate }}</th>
                              <th scope="col">{{ 'stats.noResponse' | translate }}</th>
                              <th scope="col">{{ 'stats.notInvited' | translate }}</th>
                              <th scope="col">{{ 'stats.declined' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (stats of rankedSeasonStats(seasonStats); track stats; let statsIndex = $index) {
                                <tr>
                                  <th scope="row" class="text-truncate player-name" title="{{stats.playerName}}">
                                    {{statsIndex + 1 + '. ' + stats.playerName}}
                                    <span>{{(statsIndex === 0) ? '🏆' :''}}</span>
                                  </th>
                                  <td>{{statsMetricScore(stats) | number:'1.2-2'}}</td>
                                  <td>{{stats.playerWins}}</td>
                                  <td>{{stats.playerLoses}}</td>
                                  <td>{{stats.playerDraws}}</td>
                                  <td>{{stats.playerScored}}</td>
                                  <td>{{stats.playerConceded}}</td>
                                  <td>{{stats.playedAsWhites}}</td>
                                  <td>{{stats.playedAsBlacks}}</td>
                                  <td>{{stats.didNotRespond}}</td>
                                  <td>{{stats.wasNotInvited}}</td>
                                  <td>{{stats.declinedInvite}}</td>
                                </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                      <div class="stats-card-list">
                        @for (stats of rankedSeasonStats(seasonStats); track stats; let statsIndex = $index) {
                            <details class="stats-player-card">
                              <summary class="stats-player-card-main">
                                <div class="stats-player-card-rank">#{{statsIndex + 1}}</div>
                                <div class="stats-player-card-name">
                                  {{stats.playerName}}
                                  <span>{{(statsIndex === 0) ? '🏆' :''}}</span>
                                </div>
                                <div class="stats-player-card-score">
                                  <strong>{{statsMetricScore(stats) | number:'1.2-2'}}</strong>
                                </div>
                                <i [class]="('common.chevronDown' | nogoshIcon) + ' stats-player-card-toggle'" aria-hidden="true"></i>
                              </summary>
                              <dl class="stats-player-card-grid">
                                <div class="stats-player-card-row stats-player-card-row-three">
                                  <div><dt>{{ 'stats.wins' | translate }}</dt><dd>{{stats.playerWins}}</dd></div>
                                  <div><dt>{{ 'stats.draws' | translate }}</dt><dd>{{stats.playerDraws}}</dd></div>
                                  <div><dt>{{ 'stats.losses' | translate }}</dt><dd>{{stats.playerLoses}}</dd></div>
                                </div>
                                <div class="stats-player-card-row stats-player-card-row-three">
                                  <div><dt>{{ 'stats.teamScored' | translate }}</dt><dd>{{stats.playerScored}}</dd></div>
                                  <div><dt>{{ 'stats.teamConceded' | translate }}</dt><dd>{{stats.playerConceded}}</dd></div>
                                  <div><dt>{{ 'stats.goalsDelta' | translate }}</dt><dd>{{stats.playerScored - stats.playerConceded}}</dd></div>
                                </div>
                                <div class="stats-player-card-row stats-player-card-row-two">
                                  <div><dt>{{ 'stats.playedWhites' | translate }}</dt><dd>{{stats.playedAsWhites}}</dd></div>
                                  <div><dt>{{ 'stats.playedBlacks' | translate }}</dt><dd>{{stats.playedAsBlacks}}</dd></div>
                                </div>
                                <div class="stats-player-card-row stats-player-card-row-four">
                                  <div><dt>{{ 'stats.played' | translate }}</dt><dd>{{stats.playedGames}}</dd></div>
                                  <div><dt>{{ 'stats.declined' | translate }}</dt><dd>{{stats.declinedInvite}}</dd></div>
                                  <div><dt>{{ 'stats.noResponse' | translate }}</dt><dd>{{stats.didNotRespond}}</dd></div>
                                  <div><dt>{{ 'stats.notInvited' | translate }}</dt><dd>{{stats.wasNotInvited}}</dd></div>
                                </div>
                              </dl>
                            </details>
                        }
                      </div>
                    </details>
                  } @else {
                    <section class="stats-season stats-season-empty" aria-labelledby="inline-stats-season-empty-{{seasonIndex}}">
                      <div class="stats-season-header stats-season-empty-header">
                        <span class="stats-season-heading">
                          <span id="inline-stats-season-empty-{{seasonIndex}}" class="stats-season-title">{{inlineEventStats.event.name}}</span>
                          <span class="stats-season-dates">
                            @if (seasonStatsPeriod(seasonStats) === 'allTime') {
                              <span>{{ 'stats.allTime' | translate }}</span>
                            } @else {
                              <span>{{seasonStats.seasonStart | localizedDate:'MMM yyyy'}}</span>
                              <span>{{seasonStats.seasonEnd | localizedDate:'MMM yyyy'}}</span>
                            }
                          </span>
                        </span>
                        <span class="stats-season-empty-message">{{ 'stats.emptySeasonMessage' | translate }}</span>
                      </div>
                    </section>
                  }
                }
                </div>
              </div>
              } @else {
                <section class="stats-empty-state" role="status">
                  <div class="stats-empty-state-mark" aria-hidden="true">
                    <i [class]="'match.stats' | nogoshIcon"></i>
                  </div>
                  <h3>{{ 'stats.emptyTitle' | translate }}</h3>
                  <p>{{ 'stats.emptyDescription' | translate }}</p>
                  <div class="stats-empty-state-steps">
                    <div><i [class]="'match.editResult' | nogoshIcon" aria-hidden="true"></i><span>{{ 'stats.emptyResultStep' | translate }}</span></div>
                    <div><i [class]="'match.seasons' | nogoshIcon" aria-hidden="true"></i><span>{{ 'stats.emptySeasonStep' | translate }}</span></div>
                    <div><i [class]="'match.rating' | nogoshIcon" aria-hidden="true"></i><span>{{ 'stats.emptyRankingStep' | translate }}</span></div>
                  </div>
                </section>
              }
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="closeMatchInfoEditor()">{{ 'common.close' | translate }}</button>

              @if (!inlineStatsLoading) {

              }
            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'history') {
          <div class="add-players-detail-screen">
            @if (inlineHistoryErrorMsg) {
              <div class="alert alert-danger" role="alert">{{ inlineHistoryErrorMsg }}</div>
            }
	            @if (inlineHistoryLoading && inlineHistoryEvents.length === 0) {
	              <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
	            }
            <section class="event-history-list" [attr.aria-label]="'events.history' | translate">
              @for (historyEvent of inlineHistoryEvents; track historyEvent.id) {
                <article id="history-event-{{historyEvent.id}}"
                  class="card event-history-card"
                  [class.event-history-card-clickable]="canOpenHistoryEventDetails(historyEvent)"
                  [attr.role]="canOpenHistoryEventDetails(historyEvent) ? 'button' : null"
                  [attr.tabindex]="canOpenHistoryEventDetails(historyEvent) ? '0' : null"
                  (click)="openHistoryEventDetails(historyEvent)"
                  (keydown.enter)="openHistoryEventDetails(historyEvent)"
                  (keydown.space)="$event.preventDefault(); openHistoryEventDetails(historyEvent)">
                  <div class="event-history-card-body">
                    <div class="event-history-card-header">
                      <div class="event-history-card-title event-history-date-copy">
                        <h3>{{ historyDateTimeLabel(historyEvent) }}</h3>
                        <div>
                          @if (getHistoryLocation(historyEvent) !== '-') {
                            <p class="event-history-card-location">{{ getHistoryLocation(historyEvent) }} <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i></p>
                          }
                        </div>
                        @if (historyEvent.cancelled === true && historyEvent.cancelReason) {
                          <p class="event-history-cancel-reason">{{historyEvent.cancelReason}}</p>
                        }
                      </div>
                    </div>
                    <div class="event-history-meta">
                      <div>
                        <span>{{ 'events.playersShowedUp' | translate }}</span>
                        <strong>{{historyConfirmedCount(historyEvent)}}/{{historyMaxPlayers(historyEvent)}}</strong>
                      </div>
                    </div>
                    @if (hasHistoryRoster(historyEvent)) {
	                      <section class="event-history-result" [attr.aria-label]="'events.score' | translate">
	                        <div class="history-detail-rounds event-history-rounds">
	                          @for (game of displayHistoryRosterGames(historyEvent); track game.roundNumber) {
	                            <section class="history-detail-round">
	                              <header class="history-detail-round-header">
	                                <span>{{ resultRoundLabel(game) }}</span>
                                  @if (hasResult(historyEvent)) {
	                                  <strong>
	                                    <i [class]="('player.team' | nogoshIcon) + ' event-history-white-shirt'" aria-hidden="true"></i>
	                                    <span class="history-detail-round-score">{{game.whiteScore}} : {{game.blackScore}}</span>
	                                    <i [class]="('player.team' | nogoshIcon) + ' event-history-black-shirt'" aria-hidden="true"></i>
	                                  </strong>
                                  } @else {
                                    <strong class="history-detail-round-roster-label">{{ 'events.roster' | translate }}</strong>
                                  }
	                              </header>
	                              <div class="history-detail-round-teams">
	                                <div class="history-detail-round-team">
	                                  @for (playerEventInfo of gameTeamPlayers(historyEvent, game, playerEventInfoJersey.WHITE); track playerEventInfo.id) {
	                                    <div class="history-detail-round-player">
	                                      @if (playerEventInfo.player.avatar) {
	                                        <img [src]="playerEventInfo.player.avatar" [alt]="getPlayerDisplayName(playerEventInfo)" onerror="this.style.display='none'">
	                                      } @else {
	                                        <span>{{getPlayerInitials(playerEventInfo)}}</span>
	                                      }
	                                      <b>{{getPlayerDisplayName(playerEventInfo)}}</b>
	                                    </div>
	                                  }
	                                </div>
                                  @if (hasResult(historyEvent) && historyRoundOutcomeKey(game) !== 'nothing') {
                                    <div class="history-detail-round-outcome" [ngClass]="'history-detail-round-outcome-' + historyRoundOutcomeKey(game)">
                                      @if (historyRoundOutcomeKey(game) === 'won') {
                                        <i [class]="'match.rating' | nogoshIcon" aria-hidden="true"></i>
                                      } @else if (historyRoundOutcomeKey(game) === 'lost') {
                                        <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                                      } @else if (historyRoundOutcomeKey(game) === 'drew') {
                                        <i [class]="'common.minus' | nogoshIcon" aria-hidden="true"></i>
                                      }
                                      <span>{{ historyRoundOutcomeLabel(game) }}</span>
                                    </div>
                                  } @else {
                                    <div class="history-detail-round-outcome history-detail-round-outcome-empty" aria-hidden="true"></div>
                                  }
	                                <div class="history-detail-round-team">
	                                  @for (playerEventInfo of gameTeamPlayers(historyEvent, game, playerEventInfoJersey.BLACK); track playerEventInfo.id) {
	                                    <div class="history-detail-round-player">
	                                      @if (playerEventInfo.player.avatar) {
	                                        <img [src]="playerEventInfo.player.avatar" [alt]="getPlayerDisplayName(playerEventInfo)" onerror="this.style.display='none'">
	                                      } @else {
	                                        <span>{{getPlayerInitials(playerEventInfo)}}</span>
	                                      }
	                                      <b>{{getPlayerDisplayName(playerEventInfo)}}</b>
	                                    </div>
	                                  }
	                                </div>
	                              </div>
	                            </section>
	                          }
	                        </div>
	                      </section>
	                    }
                    <div class="event-history-actions">
                      @if (canEnterResult(historyEvent)) {
                        <button type="button" (click)="openResultDialog(historyEvent); $event.stopPropagation()" class="btn btn-sm btn-primary">
                          {{ hasResult(historyEvent) ? ('events.editResult' | translate) : ('events.enterResult' | translate) }}
                        </button>
                      }
                    </div>
                  </div>
                </article>
              }
            </section>
            @if (!inlineHistoryLoading && inlineHistoryEvents.length === 0) {
              <p class="event-history-empty">{{ 'events.noPlayedMatches' | translate }}</p>
            }
            @if (inlineHistoryEvents.length >= inlineHistoryPageSize) {
              <div class="event-history-load-more">
                <button type="button" class="btn btn-secondary btn-sm px-3 text-white" [disabled]="inlineHistoryLoading" (click)="loadMoreInlineHistory()">{{ 'common.more' | translate }}</button>
              </div>
            }
            <div appActionBar class="match-info-edit-actions">
              <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="closeMatchInfoEditor()">{{ 'common.close' | translate }}</button>

              @if (!inlineHistoryLoading) {

              }
            </div>
          </div>
        }
        @if (matchInfoEditorMode === 'balanceTeams') {
          <app-team-board [event]="event" (rosterChanged)="balanceRosterChanged($event)" (player)="openMngPlayerDetail($event, event)"></app-team-board>
          <div appActionBar class="match-info-edit-actions">
            <button type="button" class="btn btn-secondary" (click)="closeMatchInfoEditor()">{{ 'common.close' | translate }}</button>
          </div>
        }
      </section>
    }
    @if (!matchInfoEditorMode && !showRoster && !event.historyEvent) {
      <div class="match-overview-layout" data-testid="match-overview">
        <app-match-home [event]="event" [chat]="homeChat" [detail]="true" [busy]="loading || matchInfoSaving || responseSaving" (attendance)="overviewAttendance($event)" (action)="overviewAction($event)"></app-match-home>
        <div class="match-overview-content">
          <p *ngIf="matchInfoErrorMsg" role="alert" class="text-danger">{{ matchInfoErrorMsg }}</p>
          <p *ngIf="responseError" role="alert" class="text-danger">{{ 'events.saveResponseError' | translate }}</p>
          <nav class="match-utility-grid" [attr.aria-label]="'events.details' | translate">
            <button type="button" (click)="openOverviewRoster()"><i aria-hidden="true" [class]="'match.addPlayers' | nogoshIcon"></i>{{ 'events.players' | translate }}</button>
            <button type="button" (click)="event.viewedByManager ? openMatchRulesEditor() : openMatchRulesViewer()"><i aria-hidden="true" [class]="'match.rulebook' | nogoshIcon"></i>{{ 'events.rulebook' | translate }}</button>
            <button type="button" [disabled]="!canViewStatsAndHistory(event)" (click)="openStats(event)"><i aria-hidden="true" [class]="'match.stats' | nogoshIcon"></i>{{ 'stats.title' | translate }}</button>
            <button type="button" [disabled]="!canViewStatsAndHistory(event)" (click)="openHistory(event)"><i aria-hidden="true" [class]="'match.history' | nogoshIcon"></i>{{ 'events.history' | translate }}</button>
            <button type="button" [disabled]="!homeChat?.id" [title]="(!homeChat?.id ? 'chat.matchChatMissing' : 'players.chat') | translate" (click)="overviewAction('chat')"><i aria-hidden="true" [class]="'chat.chat' | nogoshIcon"></i>{{ 'players.chat' | translate }}</button>
            <button *ngIf="event.viewedByManager" type="button" (click)="openSettingsPage()"><i aria-hidden="true" [class]="'match.settings' | nogoshIcon"></i>{{ 'settings.title' | translate }}</button>
            <button *ngIf="!event.viewedByManager && canUsePlayerSettings(event)" type="button" (click)="openLeaveTeamDialog(event)"><i aria-hidden="true" [class]="'common.close' | nogoshIcon"></i>{{ leaveTeamActionKey(event) | translate }}</button>
          </nav>
          <p *ngIf="!homeChat?.id" class="text-nogosh-grey3 text-sm">{{ 'chat.matchChatMissing' | translate }}</p>
          <section *ngIf="event.viewedByManager && homeChat" class="match-announcement">
            <button type="button" class="btn btn-outline-primary" (click)="announcementOpen = !announcementOpen">{{ 'events.managerAnnouncementAction' | translate }}</button>
            <button *ngIf="homeChat.managerAnnouncement" type="button" class="btn btn-outline-danger" [disabled]="announcementSaving" (click)="removeAnnouncement()">{{ 'events.managerAnnouncementRemove' | translate }}</button>
            <div *ngIf="announcementOpen">
              <label for="manager-announcement">{{ 'events.managerAnnouncementTitle' | translate }}</label>
              <textarea id="manager-announcement" class="form-control" maxlength="500" rows="3" [(ngModel)]="announcementText" [disabled]="announcementSaving" [placeholder]="'events.managerAnnouncementPlaceholder' | translate"></textarea>
              <p *ngIf="announcementError" role="alert" class="text-danger">{{ announcementError }}</p>
              <div class="match-overview-actions"><button type="button" class="btn btn-secondary" [disabled]="announcementSaving" (click)="announcementOpen = false">{{ 'common.cancel' | translate }}</button><button type="button" class="btn btn-primary" [disabled]="announcementSaving || !announcementText.trim()" (click)="confirmAnnouncement()">{{ 'common.send' | translate }}</button></div>
            </div>
          </section>
          <section class="match-configuration" data-testid="match-configuration" [attr.aria-label]="'events.details' | translate">
            <button type="button" [disabled]="!canEditMatchInfo()" (click)="openConfigurationEditor('time')"><span class="configuration-label">{{ 'events.time' | translate }}</span><span>{{ event.nextOccurrenceTimestamp ? (event.nextOccurrenceTimestamp | localizedDate:'EEE, d MMM') : ('events.timeNotSet' | translate) }}<ng-container *ngIf="event.nextOccurrenceTimestamp"> · {{ event.nextOccurrenceTimestamp | timezone:event.nextOccurrenceTimestampZone:'HH:mm' }}</ng-container></span></button>
            <button type="button" [disabled]="!canEditMatchInfo()" (click)="openConfigurationEditor('location')"><span class="configuration-label">{{ 'common.location' | translate }}</span><span>{{ eventLocationLabel() }}</span></button>
            <button type="button" [disabled]="!canEditMatchInfo()" (click)="openConfigurationEditor('maxPlayers')"><span class="configuration-label">{{ 'events.maxPlayers' | translate }}</span><span>{{ event.maxPlayers }}</span></button>
            <button type="button" [disabled]="!canEditMatchInfo()" (click)="openConfigurationEditor('occurrence')"><span class="configuration-label">{{ 'events.settingsSetOccurrence' | translate }}</span><span>{{ matchSettingsOccurrenceStatus() }}</span></button>
            <button type="button" [disabled]="!canEditMatchInfo()" (click)="openConfigurationEditor('visibility')"><span class="configuration-label">{{ 'events.visibility' | translate }}</span><span>{{ matchSettingsVisibilityStatus() }}</span></button>
            <button type="button" [disabled]="!canEditMatchInfo()" (click)="openConfigurationEditor('seasons')"><span class="configuration-label">{{ 'events.settingsSetSeasons' | translate }}</span><span>{{ matchSettingsSeasonsStatus() }}</span></button>
          </section>
          <div *ngIf="showIncompleteSetupNotice()" class="match-overview-actions"><button appSaveAction [saved]="matchInfoSaved" [saving]="matchInfoSaving" class="btn btn-primary" [disabled]="matchInfoSaving" (click)="saveIncompleteSetupMatch()">{{ 'common.save' | translate }}</button></div>
        </div>
      </div>
    }
    @if (!matchInfoEditorMode && showRoster && !event.viewedByManager && !event.historyEvent) {
      <section class="member-roster" data-testid="member-roster">
        <div class="member-roster-controls">
          <div class="member-roster-tabs" role="tablist" [attr.aria-label]="'events.players' | translate">
            @for (tab of ['FIRST_TEAM', 'RESERVE', 'ALL']; track tab) {
              <button type="button" role="tab" [attr.aria-selected]="memberRosterTab === tab" [class.selected]="memberRosterTab === tab" (click)="memberRosterTab = tab">{{ (tab === 'FIRST_TEAM' ? 'notifications.firstTeam' : tab === 'RESERVE' ? 'notifications.reserves' : 'players.allPlayers') | translate }}</button>
            }
          </div>
          <button type="button" class="member-roster-search-toggle" [class.selected]="memberRosterSearchOpen" [attr.aria-label]="'players.findPlayer' | translate" [attr.aria-expanded]="memberRosterSearchOpen" (click)="memberRosterSearchOpen = !memberRosterSearchOpen"><i class="fa fa-search" aria-hidden="true"></i></button>
        </div>
        @if (memberRosterSearchOpen) {
          <input type="search" class="form-control member-roster-search" [(ngModel)]="memberRosterSearch" [placeholder]="'players.findPlayer' | translate" [attr.aria-label]="'players.findPlayer' | translate">
        }
        <section class="member-roster-section" role="tabpanel">
          <header><h2>{{ memberRosterTitleKey() | translate }}</h2><span>{{ memberRosterPlayers(false).length }}</span></header>
          @for (info of memberRosterPlayers(); track info.id) {
            <button type="button" class="member-roster-row" (click)="openMngPlayerDetail(info, event)">
              <span class="member-roster-avatar" [class.is-manager]="info.player.id === event.manager?.id" [class.is-current]="info.player.id === currentPlayer?.id" [class.is-reserve]="info.teamMemberType === 'RESERVE'">
                @if (info.player.avatar) { <img [src]="info.player.avatar" alt=""> } @else { <span>{{ getPlayerInitials(info) }}</span> }
                @if (info.player.id === event.manager?.id) { <b class="member-roster-manager">M</b> }
                @if (info.teamMemberType) { <i class="member-roster-team" [ngClass]="(info.teamMemberType === 'FIRST_TEAM' ? 'match.status.firstTeam' : info.teamMemberType === 'RESERVE' ? 'match.time' : 'match.addPlayers') | nogoshIcon" aria-hidden="true"></i> }
              </span>
              <strong>{{ getPlayerDisplayName(info) }}</strong>
              @if ((info.player.ratingSummaryIncluded ? info.player.ratingAverageOffence : memberRosterRating(info.player.ratingOffence)) || (info.player.ratingSummaryIncluded ? info.player.ratingAverageDefence : memberRosterRating(info.player.ratingDefence))) {
                <span class="member-roster-ratings"><span>O ★{{ (info.player.ratingSummaryIncluded ? info.player.ratingAverageOffence : memberRosterRating(info.player.ratingOffence)) || '–' }}</span><span>D ★{{ (info.player.ratingSummaryIncluded ? info.player.ratingAverageDefence : memberRosterRating(info.player.ratingDefence)) || '–' }}</span></span>
              }
              @if (memberRosterStatusKey(info.status)) {
                <span class="member-roster-status" [attr.data-status]="info.status"><i [class]="(info.status === 'CONFIRMED' ? 'common.check' : info.status === 'DECLINED' ? 'match.status.declined' : info.status === 'NOT_ANSWERED' ? 'match.status.notAnswered' : 'match.status.notNotified') | nogoshIcon" aria-hidden="true"></i>{{ memberRosterStatusKey(info.status) | translate }}</span>
              }
            </button>
          } @empty {
            <p class="member-roster-empty">{{ (memberRosterSearchOpen && memberRosterSearch.trim() ? 'events.rosterSearchEmpty' : 'events.rosterEmptyAll') | translate }}</p>
          }
        </section>
      </section>
    }
    @if (!matchInfoEditorMode && ((showRoster && event.viewedByManager) || event.historyEvent)) {
    <form #eventForm="ngForm" autocomplete="off">
      @if (!showHelp) {
        <div class="form-group">
          @if (!loading) {
            <div class="match-overview-card mb-4">
              @if (showIncompleteSetupNotice()) {
                <section class="match-draft-notice" role="status">
                  <span class="match-draft-icon" aria-hidden="true">
                    <i [class]="'common.edit' | nogoshIcon"></i>
                  </span>
                  <span class="match-draft-copy">
                    <strong>{{ 'events.incompleteSetupTitle' | translate }}</strong>
                    <span>{{ 'events.incompleteSetupDescription' | translate }}</span>
                  </span>
                  <span class="match-draft-actions">
                    <button type="button" class="match-draft-save" [disabled]="matchInfoSaving || deleteMatchLoading" (click)="saveIncompleteSetupMatch()">
                      @if (matchInfoSaving) {
                        <app-delayed-indicator></app-delayed-indicator>
                      }
                      {{ 'events.saveTeam' | translate }}
                    </button>
                    <button type="button" class="match-draft-cancel" [disabled]="matchInfoSaving || deleteMatchLoading" (click)="cancelIncompleteSetupMatch()">
                      @if (deleteMatchLoading) {
                        <app-delayed-indicator></app-delayed-indicator>
                      }
                      {{ 'common.cancel' | translate }}
                    </button>
                  </span>
                </section>
              }
              @if (event.cancelled === true) {
                <section class="match-cancelled-notice" role="status">
                  <span class="match-cancelled-icon" aria-hidden="true">
                    <i [class]="'match.cancel' | nogoshIcon"></i>
                  </span>
                  <span class="match-cancelled-copy">
                    <strong>{{ 'events.cancelledMatchTitle' | translate }}</strong>
                    <span>{{ cancelledMatchDescription() }}</span>
                  </span>
                  @if (event.viewedByManager) {
                    <button type="button" class="match-cancelled-restore" [disabled]="uncancelMatchInProgress" (click)="uncancelMatch()">
                      @if (uncancelMatchInProgress) {
                        <app-delayed-indicator></app-delayed-indicator>
                      }
                      {{ 'events.uncancelMatchShort' | translate }}
                    </button>
                  }
                </section>
                @if (uncancelMatchErrorMsg) {
                  <div class="alert alert-danger mt-3" role="alert">{{ uncancelMatchErrorMsg }}</div>
                }
              }
              <div class="match-detail-summary-card match-detail-summary-lines">
                <button type="button" class="match-detail-summary-item" [ngClass]="{'is-editable': canEditMatchInfo()}" [disabled]="!canEditMatchInfo()" (click)="openMatchTimeEditor()">
                  <span class="match-detail-summary-content">
                    @if (event.nextOccurrenceTimestamp) {
                      <span class="match-detail-summary-value match-detail-summary-primary">
                        {{ 'events.dateTimeAt' | translate:{
                          date: ((isMatchWithinNextWeek() ? (event.nextOccurrenceTimestamp | localizedDate:'EEEE') : (event.nextOccurrenceTimestamp | localizedDate:'d MMMM')) | uppercase),
                          time: (event.nextOccurrenceTimestamp | timezone:event.nextOccurrenceTimestampZone:'HH:mm')
                        } }}
                      </span>
                    }
                    @if (!event.nextOccurrenceTimestamp) {
                      <span class="match-detail-summary-value match-detail-summary-primary">{{ 'events.timeNotSet' | translate }}</span>
                    }
                  </span>
                </button>
                @if (canEditMatchInfo()) {
                  <button type="button" class="match-detail-summary-item is-editable" (click)="openMatchLocationEditor()">
                    <span class="match-detail-summary-content">
                      <span class="match-detail-summary-secondary match-detail-summary-location-line">
                        {{ eventLocationLine() }}
                        <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </span>
                  </button>
                }
                @if (!canEditMatchInfo()) {
                  <a class="match-detail-summary-item match-detail-summary-link" [attr.href]="eventLocationMapHref()" target="_blank" rel="noopener">
                    <span class="match-detail-summary-content">
                      <span class="match-detail-summary-secondary match-detail-summary-location-line">
                        {{ eventLocationLine() }}
                        <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </span>
                  </a>
                }
		              </div>
		                @if (event.historyEvent && hasResult(event)) {
		                  <div class="history-detail-rounds">
	                    @for (game of displayGameResults(event); track game.roundNumber) {
	                      <section class="history-detail-round">
	                        <header class="history-detail-round-header">
	                          <span>{{ resultRoundLabel(game) }}</span>
	                          <strong>
	                            <i [class]="('player.team' | nogoshIcon) + ' event-history-white-shirt'" aria-hidden="true"></i>
	                            <span class="history-detail-round-score">{{game.whiteScore}} : {{game.blackScore}}</span>
	                            <i [class]="('player.team' | nogoshIcon) + ' event-history-black-shirt'" aria-hidden="true"></i>
	                          </strong>
	                        </header>
	                        <div class="history-detail-round-teams">
	                          <div class="history-detail-round-team">
	                            @for (playerEventInfo of gameTeamPlayers(event, game, playerEventInfoJersey.WHITE); track playerEventInfo.id) {
	                              <div class="history-detail-round-player">
	                                @if (playerEventInfo.player.avatar) {
	                                  <img [src]="playerEventInfo.player.avatar" [alt]="getPlayerDisplayName(playerEventInfo)" onerror="this.style.display='none'">
	                                } @else {
	                                  <span>{{getPlayerInitials(playerEventInfo)}}</span>
	                                }
	                                <b>{{getPlayerDisplayName(playerEventInfo)}}</b>
	                              </div>
	                            }
	                          </div>
                            @if (historyRoundOutcomeKey(game) !== 'nothing') {
                              <div class="history-detail-round-outcome" [ngClass]="'history-detail-round-outcome-' + historyRoundOutcomeKey(game)">
                                @if (historyRoundOutcomeKey(game) === 'won') {
                                  <i [class]="'match.rating' | nogoshIcon" aria-hidden="true"></i>
                                } @else if (historyRoundOutcomeKey(game) === 'lost') {
                                  <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                                } @else if (historyRoundOutcomeKey(game) === 'drew') {
                                  <i [class]="'common.minus' | nogoshIcon" aria-hidden="true"></i>
                                }
                                <span>{{ historyRoundOutcomeLabel(game) }}</span>
                              </div>
                            } @else {
                              <div class="history-detail-round-outcome history-detail-round-outcome-empty" aria-hidden="true"></div>
                            }
	                          <div class="history-detail-round-team">
	                            @for (playerEventInfo of gameTeamPlayers(event, game, playerEventInfoJersey.BLACK); track playerEventInfo.id) {
	                              <div class="history-detail-round-player">
	                                @if (playerEventInfo.player.avatar) {
	                                  <img [src]="playerEventInfo.player.avatar" [alt]="getPlayerDisplayName(playerEventInfo)" onerror="this.style.display='none'">
	                                } @else {
	                                  <span>{{getPlayerInitials(playerEventInfo)}}</span>
	                                }
	                                <b>{{getPlayerDisplayName(playerEventInfo)}}</b>
	                              </div>
	                            }
	                          </div>
	                        </div>
	                      </section>
		                    }
		                  </div>
		                }
                    @if (canEnterResult(event)) {
                      <div class="history-detail-result-actions">
                        <button type="button" (click)="openResultDialog(event)" class="btn btn-sm btn-primary">
                          {{ hasResult(event) ? ('events.editResult' | translate) : ('events.enterResult' | translate) }}
                        </button>
                      </div>
                    }
		              @if (!editMode && !event.historyEvent && event.cancelled !== true) {
	                <div class="match-response-card match-response-card-inline">
                  <div class="card-body py-3">
                    <div class="row player-row align-items-center">
                      <div class="col-12 d-flex justify-content-center">
                        @if (canRespondToInvite(event)) {
                          <div class="match-response-actions">
                            <div class="match-response-control"
                              [class.is-saving]="responseSaving"
                              [class.is-awaiting-response]="shouldHighlightInviteResponse(event)">
                              <button type="button"
                                class="match-response-segment match-response-play"
                                [class.is-active]="event.currentPlayerInviteStatus === playerEventInfoStatus.CONFIRMED"
                                [disabled]="responseSaving || event.active === false"
                                (click)="respondToInvite(event, playerEventInfoStatus.CONFIRMED)">
                                @if (responseSaving && pendingInviteStatus === playerEventInfoStatus.CONFIRMED) {
                                  <app-delayed-indicator></app-delayed-indicator>
                                }
                                @if (!(responseSaving && pendingInviteStatus === playerEventInfoStatus.CONFIRMED)) {
                                  <i [class]="('common.check' | nogoshIcon) + ' match-response-segment-icon'" aria-hidden="true"></i>
                                }
                                <span>{{ 'events.play' | translate }}</span>
                              </button>
                              <button type="button"
                                class="match-response-segment match-response-decline"
                                [class.is-active]="event.currentPlayerInviteStatus === playerEventInfoStatus.DECLINED"
                                [disabled]="responseSaving || event.active === false"
                                (click)="respondToInvite(event, playerEventInfoStatus.DECLINED)">
                                @if (responseSaving && pendingInviteStatus === playerEventInfoStatus.DECLINED) {
                                  <app-delayed-indicator></app-delayed-indicator>
                                }
                                @if (!(responseSaving && pendingInviteStatus === playerEventInfoStatus.DECLINED)) {
                                  <i [class]="('common.close' | nogoshIcon) + ' match-response-segment-icon'" aria-hidden="true"></i>
                                }
                                <span>{{ 'events.pass' | translate }}</span>
                              </button>
                            </div>
                            @if (isCurrentPlayerPendingTeamInvite(event)) {
                              <button type="button"
                                class="match-response-team-decline"
                                [disabled]="responseSaving || leaveTeamInProgress || event.active === false"
                                (click)="openLeaveTeamDialog(event)">
                                <i [class]="'auth.logout' | nogoshIcon" aria-hidden="true"></i>
                                <span>{{ 'events.declineTeamInvite' | translate }}</span>
                              </button>
                            }
                            @if (shouldHighlightInviteResponse(event)) {
                              <div class="match-response-helper">{{ 'events.chooseYourResponse' | translate }}</div>
                            }
                          </div>
                        }
                        @if (!canRespondToInvite(event)) {
                          <button [disabled]="true" class="btn btn-outline-primary match-response-disabled">
                            {{ 'events.youAreNotInvited' | translate }}
                          </button>
                        }
                      </div>
                    </div>
                    @if (inviteResponseStatusToDisplay(event); as inviteResponseStatus) {
                      <div class="match-response-status mt-3"
                        [class.is-confirmed]="inviteResponseStatus === playerEventInfoStatus.CONFIRMED"
                        [class.is-declined]="inviteResponseStatus === playerEventInfoStatus.DECLINED">
                        <i
                          [class]="(inviteResponseStatus === playerEventInfoStatus.CONFIRMED
                            ? ('common.selected' | nogoshIcon)
                            : ('match.status.declined' | nogoshIcon)) + ' mr-2'"
                        aria-hidden="true"></i>
                        <div class="match-response-status-content">
                          <div class="match-response-status-title">
                            {{ (inviteResponseStatus === playerEventInfoStatus.CONFIRMED ? 'events.responseSummaryComing' : 'events.responseSummaryNotComing') | translate }}
                          </div>
                        </div>
                      </div>
                    }
                    @if (responseConfirmStatus && !responseSaving) {
                      <div class="match-response-confirm mt-3">
                        <div class="d-flex align-items-start">
                          <i [class]="('common.error' | nogoshIcon) + ' mr-2 mt-1'" aria-hidden="true"></i>
                          <div>
                            <div class="match-response-status-title">{{ 'events.changeAnswer' | translate }}</div>
                            <div class="match-response-status-text">
                              {{ (responseConfirmStatus === playerEventInfoStatus.CONFIRMED ? 'events.confirmComingPrompt' : 'events.confirmNotComingPrompt') | translate }}
                            </div>
                          </div>
                        </div>
                        <div class="match-response-confirm-actions">
                          <button type="button" class="btn btn-outline-primary btn-sm" (click)="cancelInviteResponseChange()">
                            {{ 'common.cancel' | translate }}
                          </button>
                          @if (responseConfirmStatus === playerEventInfoStatus.CONFIRMED) {
                            <button type="button" class="btn btn-success btn-sm" (click)="confirmInviteResponseChange(event)">
                              {{ 'events.yesComing' | translate }}
                            </button>
                          }
                          @if (responseConfirmStatus === playerEventInfoStatus.DECLINED) {
                            <button type="button" class="btn btn-danger btn-sm" (click)="confirmInviteResponseChange(event)">
                              {{ 'events.yesNotComing' | translate }}
                            </button>
                          }
                        </div>
                      </div>
                    }
                    @if (responseResetOpen && !responseSaving) {
                      <div class="match-response-confirm mt-3">
                        <div class="d-flex align-items-start">
                          <i [class]="('match.uncancel' | nogoshIcon) + ' mr-2 mt-1'" aria-hidden="true"></i>
                          <div>
                            <div class="match-response-status-title">{{ 'events.clearResponseTitle' | translate }}</div>
                            <div class="match-response-status-text">
                              {{ 'events.clearResponsePrompt' | translate }}
                            </div>
                          </div>
                        </div>
                        <div class="match-response-confirm-actions">
                          <button type="button" class="btn btn-outline-primary btn-sm" (click)="cancelInviteResponseReset()">
                            {{ 'common.cancel' | translate }}
                          </button>
                          <button type="button" class="btn btn-warning btn-sm" (click)="resetInviteResponse(event)">
                            {{ 'events.clearResponse' | translate }}
                          </button>
                        </div>
                      </div>
                    }
                    @if (responseSaving) {
                      <div class="match-response-status is-saving mt-3">
                        <app-delayed-indicator></app-delayed-indicator>
                        <div>
                          <div class="match-response-status-title">{{ 'events.savingResponse' | translate }}</div>
                          <div class="match-response-status-text">{{ 'events.pleaseWait' | translate }}</div>
                        </div>
                      </div>
                    }
                    @if (responseError && !responseSaving) {
                      <div class="match-response-status is-error mt-3">
                        <i [class]="('common.error' | nogoshIcon) + ' mr-2'" aria-hidden="true"></i>
                        <div>
                          <div class="match-response-status-title">{{ 'events.saveResponseError' | translate }}</div>
                          <div class="match-response-status-text">{{ 'events.checkConnectionRetry' | translate }}</div>
                          <button type="button" class="btn btn-link btn-sm match-response-retry px-0" (click)="retryInviteResponse(event)">
                            <i [class]="('common.refresh' | nogoshIcon) + ' mr-1'" aria-hidden="true"></i>{{ 'common.tryAgain' | translate }}
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <!-- Refresh -->
              <!-- <div *ngIf="event.active && !editMode && event.playerEventInfos.length > 0" class="btn-sm col-auto ml-auto pr-4">
              <a href="javascript:" class="d-inline-block text-success" *ngIf="!fetchPlayerEventInfosInProgress" title="Refresh Data">
                <i [class]="('common.refresh' | nogoshIcon) + ' h5'" (click)="fetchPlayerEventInfos(event); $event.preventDefault()"><span class="sr-only">{{ 'common.refresh' | translate }}</span></i>
              </a>
              <div class="spinner-grow" role="status" *ngIf="fetchPlayerEventInfosInProgress">
                <span class="sr-only">{{ 'common.loading' | translate }}</span>
              </div>
            </div>
            Invite
            <div *ngIf="event.viewedByManager && !editMode" class="">
              <button type="button" (click)="dialogSendInviteEmail(event)" class="btn btn-sm btn-warning px-3">{{ 'players.invite' | translate }}</button>
            </div> -->
          </div>
        }
          <!-- MANAGER contact section -->
          @if (!editMode && !event.viewedByManager) {
            <div class="card match-manager-card">
              <div class="card-body">
                <div class="match-manager-row">
                  <button type="button" class="match-manager-profile-button" (click)="openManagerPlayerDetail()" [attr.aria-label]="('common.manager' | translate) + ': ' + currentManagerDisplayName()">
                    @if (event.manager.avatar) {
                      <img [src]="event.manager.avatar"
                        onerror="this.src='../../assets/images/user1.jpg'" class="rounded-circle border match-manager-avatar"
                        [alt]="'accessibility.userProfileImage' | translate">
                    } @else {
                      <span class="rounded-circle border match-manager-avatar match-manager-avatar-fallback avatar-team-fallback"
                        [ngClass]="playerAvatarTone(event.manager)" aria-hidden="true">{{playerInitials(event.manager)}}</span>
                    }
                  </button>
                  <div class="match-manager-copy">
                    <button type="button" class="match-manager-profile-name text-truncate" (click)="openManagerPlayerDetail()">{{event.manager.nickName}}</button>
                    <div class="match-manager-role text-truncate">{{ 'common.manager' | translate }}</div>
                  </div>
                  <div class="match-manager-actions">
                    <a class="match-manager-action" [attr.href]="managerPhoneHref()" [attr.aria-disabled]="!managerPhoneHref()" [attr.aria-label]="'players.call' | translate" [title]="'players.call' | translate">
                      <i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i>
                    </a>
                    <button type="button" class="match-manager-action" (click)="enterOrCreateNewChat(event.manager)" [attr.aria-label]="'players.chat' | translate" [title]="'players.chat' | translate">
                      <i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- end of MANAGER contact section -->
          <!-- STATISTICS section -->
          @if (!editMode) {
	            @if (event.viewedByManager && canUseLiveMatchActions(event)) {
	              <div class="row team-all mt-4 my-0 px-3 align-items-end">
	                <div class="auto ml-auto text-right pr-0">
                  <app-dialog [(visible)]="showNotifyAllOpenProfiles" [closable]="false" class="app-dialog--confirm">
                    <div class="modal-header">
                      <h5 class="mb-0">{{ 'notifications.sosTitle' | translate }}</h5>
                    </div>
                    <div class="modal-body">
                      <p>{{ 'notifications.sosRandom' | translate }}</p>
                      <p>{{ 'notifications.sosHelp' | translate }}</p>
                      <p>{{ 'notifications.sosOnce' | translate }}</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showNotifyAllOpenProfiles = false">{{ 'common.cancel' | translate }}</button>
                      <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="notifyAllOpenProfiles(); showNotifyAllOpenProfiles = false">{{ 'notifications.openAndSendSos' | translate }}</button>
                    </div>
                  </app-dialog>
                  <app-dialog [(visible)]="showNotifyTeammateOpenProfiles" [closable]="false" class="app-dialog--confirm">
                    <div class="modal-header">
                      <h5 class="mb-0"><i [class]="('common.warning' | nogoshIcon) + ' text-warning'"></i> {{ 'notifications.sosTeammatesTitle' | translate }}</h5>
                    </div>
                    <div class="modal-body">
                      <p>{{ 'notifications.sosTeammates' | translate }}</p>
                      <p>{{ 'notifications.sosHelp' | translate }}</p>
                      <p>{{ 'notifications.sosOnce' | translate }}</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showNotifyTeammateOpenProfiles = false">{{ 'common.cancel' | translate }}</button>
                      <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="notifyTeammateOpenProfiles(); showNotifyTeammateOpenProfiles = false">{{ 'notifications.openAndSendSos' | translate }}</button>
                    </div>
                  </app-dialog>
                    <!-- Invite link and popup -->
                    <app-dialog [(visible)]="showInactiveCleanupDialog" class="p-0 text-left">
                      <div class="modal-header">
                        <h5 class="m-0">{{ 'playerManagement.inactive.cleanupTitle' | translate }}</h5>
                      </div>
                      <div class="modal-body">
                        <p class="text-nogosh-grey3 text-sm mb-3">{{ 'playerManagement.inactive.dialogDescription' | translate }}</p>
                        <div class="form-group">
                          <label for="inactiveCleanupMonths" class="mb-0">{{ 'playerManagement.inactive.threshold' | translate }}</label>
                          <select id="inactiveCleanupMonths"
                            class="form-control"
                            [(ngModel)]="inactiveCleanupMonths"
                            [ngModelOptions]="{standalone: true}"
                            [disabled]="inactiveCleanupLoading || inactiveCleanupRemoving"
                            (change)="loadInactiveCleanupPlayers()">
                            @for (months of inactiveCleanupMonthOptions; track months) {
                              <option [ngValue]="months">{{ 'playerManagement.inactive.monthCount' | translate:{ count: months } }}</option>
                            }
                          </select>
                        </div>
                        @if (inactiveCleanupErrorMsg) {
                          <div class="alert alert-danger py-2" role="alert">{{inactiveCleanupErrorMsg}}</div>
                        }
                        @if (inactiveCleanupWarningMsg) {
                          <div class="alert alert-warning py-2" role="alert">{{inactiveCleanupWarningMsg}}</div>
                        }
                        @if (inactiveCleanupSuccessMsg) {
                          <div class="alert alert-success py-2" role="alert">{{inactiveCleanupSuccessMsg}}</div>
                        }
                        @if (inactiveCleanupLoading) {
                          <app-loading-state titleKey="playerManagement.inactive.loading" [compact]="true"></app-loading-state>
                        }
                        @if (!inactiveCleanupLoading && inactiveCleanupPlayers.length === 0 && !inactiveCleanupErrorMsg) {
                          <div class="text-nogosh-grey3 py-3">
                            {{ 'playerManagement.inactive.emptyForThreshold' | translate }}
                          </div>
                        }
                        @if (!inactiveCleanupLoading && inactiveCleanupPlayers.length > 0) {
                          <div class="table-responsive">
                            <table class="table table-sm mb-0">
                              <thead>
                                <tr>
                                  <th scope="col">
                                    <input type="checkbox"
                                      [checked]="areAllInactiveCleanupPlayersSelected()"
                                      [disabled]="inactiveCleanupRemoving"
                                      (change)="toggleAllInactiveCleanupPlayers($event.target.checked)">
                                  </th>
                                  <th scope="col">{{ 'players.player' | translate }}</th>
                                  <th scope="col">{{ 'common.status' | translate }}</th>
                                  <th scope="col">{{ 'playerManagement.type' | translate }}</th>
                                  <th scope="col">{{ 'playerManagement.inactive.lastPlayed' | translate }}</th>
                                  <th scope="col">{{ 'playerManagement.inactive.days' | translate }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (player of inactiveCleanupPlayers; track player) {
                                  <tr>
                                    <td class="align-middle">
                                      <input type="checkbox"
                                        [(ngModel)]="selectedInactivePlayerIds[player.playerId]"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="inactiveCleanupRemoving"
                                        (change)="inactiveCleanupSelectionChanged()">
                                    </td>
                                    <td class="align-middle">
                                      <div class="d-flex align-items-center">
                                        @if (player.avatar) {
                                          <img [src]="player.avatar"
                                            onerror="this.src='../../assets/images/user1.jpg'"
                                            class="rounded-circle border mr-2"
                                            style="width: 32px; height: 32px"
                                            [alt]="'accessibility.userProfileImage' | translate">
                                        } @else {
                                          <span class="rounded-circle border mr-2 inactive-player-avatar-fallback avatar-team-fallback"
                                            [ngClass]="playerAvatarTone(player)" aria-hidden="true">{{playerInitials(player)}}</span>
                                        }
                                        <div class="line-height-10">
                                          <div class="font-weight-500">{{player.nickName || player.name}}</div>
                                          @if (player.name && player.name !== player.nickName) {
                                            <div class="text-nogosh-grey3 text-sm">{{player.name}}</div>
                                          }
                                        </div>
                                      </div>
                                    </td>
                                    <td class="align-middle">{{displayPlayerEventInfoStatus(player.status)}}</td>
                                    <td class="align-middle">{{displayTeamMemberType(player.teamMemberType)}}</td>
                                    <td class="align-middle">
                                      @if (player.lastPlayedAt) {
                                        <span>{{player.lastPlayedAt | localizedDate:'d MMM yyyy'}}</span>
                                      }
                                      @if (!player.lastPlayedAt) {
                                        <span>{{ 'playerManagement.inactive.neverPlayed' | translate }}</span>
                                      }
                                    </td>
                                    <td class="align-middle">{{player.inactiveDays}}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        }
                        @if (showInactiveCleanupConfirm) {
                          <div class="alert alert-warning mt-3 mb-0" role="alert">
                            {{ 'playerManagement.removeSelectedConfirm' | translate:{ count: getSelectedInactivePlayersCount() } }}
                          </div>
                        }
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm px-3" (click)="closeInactiveCleanupDialog()" [disabled]="inactiveCleanupLoading || inactiveCleanupRemoving">{{ 'common.close' | translate }}</button>
                        <button type="button" class="btn btn-outline-primary btn-sm px-3" (click)="loadInactiveCleanupPlayers()" [disabled]="inactiveCleanupLoading || inactiveCleanupRemoving">{{ 'common.refresh' | translate }}</button>
                        @if (!showInactiveCleanupConfirm) {
                          <button type="button" class="btn btn-danger btn-sm px-3" (click)="confirmInactiveCleanupRemoval()" [disabled]="inactiveCleanupLoading || inactiveCleanupRemoving || getSelectedInactivePlayersCount() === 0">{{ 'playerManagement.removeSelected' | translate:{ count: getSelectedInactivePlayersCount() } }}</button>
                        }
                        @if (showInactiveCleanupConfirm) {
                          <button type="button" class="btn btn-danger btn-sm px-3" (click)="removeSelectedInactivePlayers()" [disabled]="inactiveCleanupRemoving || getSelectedInactivePlayersCount() === 0">
                            @if (inactiveCleanupRemoving) {
                              <app-delayed-indicator></app-delayed-indicator>
                            }
                            {{ 'playerManagement.confirmRemoval' | translate }}
                          </button>
                        }
                      </div>
                    </app-dialog>
                    <app-dialog [(visible)]="showInviteDialog" [closable]="false" class="app-dialog--form text-left">
                      <div class="modal-header">
                        <h5 class="m-0">{{ 'notifications.inviteEmailsTitle' | translate }}</h5>
                      </div>
                      <div class="modal-body">
                        <p class="app-dialog-help">{{ 'notifications.inviteEmailsHelp' | translate }}</p>
                        <span class="app-dialog-example">jon.smith&#64;test.com, smith.johnson&#64;another.com, ...</span>
                        <p class="app-dialog-help">{{ 'notifications.inviteEmailsExisting' | translate }}</p>
                        <label class="m-0" for="inviteToNogoshEmailList">{{ 'notifications.emails' | translate }}</label>
                        <textarea [title]="'notifications.emails' | translate" class="form-control" id="inviteToNogoshEmailList" #inviteToNogoshEmailList autofocus></textarea>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="showInviteDialog = false">{{ 'common.cancel' | translate }}</button>
                        <button type="button" class="btn btn-primary btn-sm px-3" (click)="sendInviteEmail(inviteToNogoshEmailList.value);">{{ 'common.send' | translate }}</button>
                      </div>
                    </app-dialog>
                    <!-- end of Invite link and popup-->
	                    <!-- add players to match -->
                    <app-dialog [(visible)]="showInvitePlayersToMatchDialog" class="p-0 text-left">
                      <div class="modal-header">
                        <h5 class="m-0">{{ 'events.addExisting' | translate }}</h5>
                      </div>
                      <div class="modal-body">
	                        {{ 'events.selectPlayersToAdd' | translate }}
	                        <input [(ngModel)]="autocompleteSelectedPlayer" typeaheadOptionsLimit="8"
	                          [placeholder]="'events.addExistingPlayerPlaceholder' | translate" autofocus [typeahead]="playerDataSource"
                          (typeaheadLoading)="changeTypeaheadLoading($event)" (typeaheadNoResults)="changeTypeaheadNoResults($event)"
                          (typeaheadOnSelect)="typeaheadPlayerNameSelected($event)" typeaheadOptionField="autocompleteName"
                          name="autocompletePlayerPicker" class="form-control" id="eventPlayers" #newPlayer autocomplete="off">
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        @if (typeaheadPlayerLoading === true) {
                          <div><i [class]="('common.refresh' | nogoshIcon) + ' ng-hide'"></i></div>
                        }
                        @if (typeaheadPlayerNoResults === true) {
                          <div><i [class]="('common.delete' | nogoshIcon) + ' col-sm-offset-1'"></i> {{ 'common.noResults' | translate }}</div>
                        }
                        <div class="mb-4 mb-md-5">
                          @for (player of selectedPlayers; track player) {
                            <div id="playersEditMode">
                              <div class="border-bottom border-bottom-not-last">
                                @if (event.viewedByManager) {
                                  <div class="row text-sm pt-2">
                                    <!-- nickname -->
                                    <div class="col-auto" title="{{player.nickName}}">
                                      <label for="playersEditMode" cl>{{player.nickName}}</label>
                                    </div>
                                    <!-- remove -->
                                    <div class="col-auto ml-auto">
                                      <a href="javascript:void(0)" class="h5 text-danger d-inline-block"
                                        (click)="removePlayerFromInviteList(player)" [ngClass]="player.id === 1 ? 'disabled' : ''"><i
                                        [class]="'common.close' | nogoshIcon"><span class="sr-only">{{ 'chat.removePlayer' | translate }}</span></i></a>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                              }<!-- #playersEditMode -->
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-sm px-3 text-white"
                            (click)="showInvitePlayersToMatchDialog =  false">{{ 'common.cancel' | translate }}</button>
                            <button type="button" class="btn btn-primary btn-sm px-3" (click)="showInvitePlayersToMatchDialog = false; callPlayersFromInviteList()">{{ 'players.invite' | translate }}</button>
                          </div>
                        </app-dialog>
                        <!-- guest players -->
                        <app-dialog [(visible)]="showGuestPlayersDialog" class="p-0 text-left">
                          <div class="modal-body">
                            @if (guestErrorMsg) {
                              <div class="text-danger mb-3">{{guestErrorMsg}}</div>
                            }
                            <p class="text-nogosh-grey3 mb-4">{{ 'guests.screenDescription' | translate }}</p>
                            <div class="mb-4">
                              <h6>{{ (selectedGuestForEdit ? 'guests.update' : 'guests.create') | translate }}</h6>
                              <label class="mb-0" for="guestName">{{ 'common.name' | translate }}</label>
                              <input [(ngModel)]="guestForm.name" type="text" class="form-control" id="guestName" name="guestName" [placeholder]="'validation.guestName' | translate" autocomplete="off">
                              <div class="d-flex mt-3">
                                @if (selectedGuestForEdit) {
                                  <button type="button" class="btn btn-secondary btn-sm px-3 mr-2 text-white" [disabled]="guestActionInProgress" (click)="cancelGuestEdit()">{{ 'guests.cancelEdit' | translate }}</button>
                                }
                                <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="guestActionInProgress || !(guestForm.name || '').trim()" (click)="saveGuest()">{{ (selectedGuestForEdit ? 'guests.update' : 'guests.create') | translate }}</button>
                              </div>
                            </div>
                            <div class="border-top pt-3">
                              @if (guestPlayers.length === 0) {
                                <div class="text-nogosh-grey3 text-sm">{{ 'guests.empty' | translate }}</div>
                              }
                              @for (guest of guestPlayers; track guest) {
                                <div class="py-2 border-bottom border-bottom-not-last">
                                  <div class="d-flex flex-column flex-md-row align-items-md-center">
                                    <div class="flex-fill text-sm font-weight-500 mb-2 mb-md-0" title="{{getGuestDisplayName(guest)}}">
                                      <div>{{getGuestDisplayName(guest)}}</div>
                                      <div class="text-nogosh-grey3 text-sm mt-1">{{ 'guests.managedPlayer' | translate }}</div>
                                    </div>
                                    <div class="d-flex flex-wrap justify-content-start justify-content-md-end">
                                      <button type="button" class="btn btn-sm btn-outline-primary px-3 my-1 mr-1" [disabled]="guestActionInProgress" (click)="startEditGuest(guest)">{{ 'common.edit' | translate }}</button>
                                      <button type="button" class="btn btn-sm btn-outline-danger px-3 my-1" [disabled]="guestActionInProgress" (click)="dialogDeactivateGuest(guest)">{{ 'common.deactivate' | translate }}</button>
                                    </div>
                                  </div>
                                </div>
                              }
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="showGuestPlayersDialog = false;cancelGuestEdit()">{{ 'common.close' | translate }}</button>
                        </div>
                      </app-dialog>
                      <app-dialog [(visible)]="showDeactivateGuestDialog">
                        <div class="modal-header">
                          <h5 class="mb-0">{{ 'guests.deactivateTitle' | translate }}</h5>
                        </div>
                        <div class="modal-body">
                          <p>{{ 'guests.deactivateDescription' | translate }}</p>
                          @if (guestForDeactivate) {
                            <p>{{ 'guests.managedPlayer' | translate }}: <b>{{getGuestDisplayName(guestForDeactivate)}}</b></p>
                          }
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="guestActionInProgress" (click)="showDeactivateGuestDialog = false;guestForDeactivate = null">{{ 'common.cancel' | translate }}</button>
                          <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="guestActionInProgress" (click)="deactivateGuest()">{{ 'guests.deactivateAction' | translate }}</button>
                        </div>
                      </app-dialog>
                      <!-- call new user to Nogosh -->
                    </div>
                  </div>
                }
              }
              <!-- end of STATISTICS section -->
              <!-- end of YOUR ANSWER section -->
              <!-- player autocomplete -->
              <!-- <div *ngIf="editMode" class="col-xs-12 mt-2">
              <input [(ngModel)]="autocompleteSelectedPlayer" typeaheadOptionsLimit="10" placeholder="Add existing Footballer player ( * for all )" autofocus
                [typeahead]="playerDataSource" (typeaheadLoading)="changeTypeaheadLoading($event)"
                (typeaheadNoResults)="changeTypeaheadNoResults($event)"
                (typeaheadOnSelect)="typeaheadPlayerNameSelected($event); addPlayerToTheEvent(autocompleteSelectedPlayer.email)"
                typeaheadOptionField="autocompleteName" name="autocompletePlayerPicker"
                class="form-control" id="eventPlayers" #newPlayer autocomplete="off" >
              <div *ngIf="typeaheadPlayerLoading === true"><i [class]="('common.refresh' | nogoshIcon) + ' ng-hide'"></i></div>
              <div *ngIf="typeaheadPlayerNoResults === true"><i [class]="('common.delete' | nogoshIcon) + ' col-sm-offset-1'"></i> {{ 'common.noResults' | translate }}</div>
            </div> -->
            <!-- CANDIDATES section -->
            @if (!editMode && !event.historyEvent && newCandidatesInfoList.length>0) {
              <div>
                <div class="mt-3 mb-2 pl-3">
                  <b class="text-left fr-header">{{ 'events.candidates' | translate }}</b>
                </div>
              </div>
            }
            @if (!editMode && !event.historyEvent && newCandidatesInfoList.length>0 ) {
              <div>
                <div class="players-list-wrapper card">
                  <div class="card-body px-3 py-0">
                    @for (playerEventInfo of newCandidatesInfoList; track playerEventInfo) {
                      <div id="candidatesList" class="players-list py-2 border-bottom border-bottom-not-last">
                        @if (playerEventInfo.teamMemberType === teamMemberType.CANDIDATE) {
                          <div>
                            <div class="row player-row align-items-center">
                              <div class="col-auto pr-2 pr-sm-3">
                                <div class="avatar-team player-team-avatar is-manager-added-avatar"
                                  [title]="'guestOwner.addedByManager' | translate"
                                  [attr.aria-label]="'guestOwner.addedByManager' | translate">
                                  @if (playerEventInfo.player.avatar) {
                                    <img [src]="playerEventInfo.player.avatar"
                                      onerror="this.src='../../assets/images/user1.jpg'" class="rounded-circle border" style="width: 40px; height: 40px"
                                      [alt]="'accessibility.userProfileImage' | translate">
                                  } @else {
                                    <span class="rounded-circle border player-avatar-fallback avatar-team-fallback"
                                      [ngClass]="playerEventInfoAvatarTone(playerEventInfo)" aria-hidden="true">{{getPlayerInitials(playerEventInfo)}}</span>
                                  }
                                  <span class="player-team-status-icon" aria-hidden="true">
                                    <i [class]="'match.inviteGuest' | nogoshIcon"></i>
                                  </span>
                                </div>
                              </div>
                              <div class="col pl-0 text-sm font-weight-500 players-nickname d-flex flex-column justify-content-center line-height-10"
                                title="{{playerEventInfo.player.nickName}}">
                                {{playerEventInfo.player.nickName}}
                              </div>
                              @if (this.event.viewedByManager) {
                                <div class="col-sm-auto ml-3 px-3 ml-sm-auto d-flex justify-content-center">
                                  <button (click)="openMngPlayerDetail(playerEventInfo, event); $event.preventDefault()" class="btn  mr-sm-3 px-4 btn-outline-primary">{{ 'players.info' | translate }}</button>
                                  @if (canUseLiveMatchActions(event)) {
                                    <button (click)="approveJoinRequest(playerEventInfo); $event.preventDefault()" class="btn  ml-sm-3 px-4 btn-outline-primary">{{ 'events.accept' | translate }}</button>
                                  }
                                  @if (canUseLiveMatchActions(event)) {
                                    <button (click)="removePlayerFromTheEvent(playerEventInfo); $event.preventDefault()" class="btn  ml-3 px-4 btn-outline-primary">{{ 'events.deny' | translate }}</button>
                                  }
                                </div>
	                              }
	                            </div>
	                          </div>
	                        }
	                      </div>
	                    }
	                  </div>
	                </div>
	              </div>
	            }
            <!-- end of CANDIDATES section -->
            <app-dialog [(visible)]="showResultDialog">
              <div class="modal-header event-result-modal-header">
                <h5 class="modal-title">{{ resultEvent && hasResult(resultEvent) ? ('events.editResult' | translate) : ('events.enterResult' | translate) }}</h5>
              </div>
	              <div class="modal-body event-result-modal-body">
	                @if (resultLoading) {
	                  <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
	                }
	                @for (game of resultGames; track game.roundNumber; let gameIndex = $index) {
	                  <section class="event-result-game">
	                    <div class="event-result-game-header">
	                      <h6 class="mb-0">{{ resultRoundLabel(game) }}</h6>
                      @if (resultGames.length > 1) {
                        <button type="button" class="event-result-remove" (click)="removeResultGame(gameIndex)" [disabled]="resultSaving" [attr.aria-label]="'common.remove' | translate">
                          <i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i>
	                        </button>
	                      }
	                    </div>
	                    <div class="event-result-score-row">
	                      <div class="event-result-score-field">
	                        <input type="number" min="0" class="form-control text-center" name="resultWhiteScore{{gameIndex}}" [(ngModel)]="game.whiteScore" [disabled]="resultSaving">
	                      </div>
	                      <div class="event-result-score-separator">:</div>
	                      <div class="event-result-score-field">
	                        <input type="number" min="0" class="form-control text-center" name="resultBlackScore{{gameIndex}}" [(ngModel)]="game.blackScore" [disabled]="resultSaving">
	                      </div>
	                    </div>
	                    <div class="event-result-round-teams">
	                      <div class="event-result-round-team">
	                        @for (playerEventInfo of gameTeamPlayers(resultEvent, game, playerEventInfoJersey.WHITE); track playerEventInfo.id) {
	                          <div class="event-result-round-player">
	                            <button type="button" class="event-result-round-player-name" (click)="toggleGamePlayerJersey(game, playerEventInfo.player.id)" [disabled]="resultSaving">
	                              {{getPlayerDisplayName(playerEventInfo)}}
	                            </button>
	                            <button type="button" class="event-result-round-player-remove" (click)="removeGamePlayer(game, playerEventInfo.player.id)" [disabled]="resultSaving" [attr.aria-label]="'common.remove' | translate">
	                              <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
	                            </button>
	                          </div>
	                        }
	                      </div>
	                      <div class="event-result-round-team">
	                        @for (playerEventInfo of gameTeamPlayers(resultEvent, game, playerEventInfoJersey.BLACK); track playerEventInfo.id) {
	                          <div class="event-result-round-player">
	                            <button type="button" class="event-result-round-player-name" (click)="toggleGamePlayerJersey(game, playerEventInfo.player.id)" [disabled]="resultSaving">
	                              {{getPlayerDisplayName(playerEventInfo)}}
	                            </button>
	                            <button type="button" class="event-result-round-player-remove" (click)="removeGamePlayer(game, playerEventInfo.player.id)" [disabled]="resultSaving" [attr.aria-label]="'common.remove' | translate">
	                              <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
	                            </button>
	                          </div>
	                        }
	                      </div>
	                    </div>
	                    @if (gameAvailablePlayers(resultEvent, game).length > 0) {
		                      <div class="event-result-bench">
		                        @for (playerEventInfo of gameAvailablePlayers(resultEvent, game); track playerEventInfo.id) {
                          <div class="event-result-bench-player">
                            <span>{{getPlayerDisplayName(playerEventInfo)}}</span>
                            <div class="event-result-bench-actions">
                              <button type="button" class="event-result-bench-team" (click)="setGamePlayerJersey(game, playerEventInfo.player.id, playerEventInfoJersey.WHITE)" [disabled]="resultSaving" [attr.aria-label]="('events.whiteTeam' | translate) + ': ' + getPlayerDisplayName(playerEventInfo)">
                                <i [class]="('player.team' | nogoshIcon) + ' event-history-white-shirt'" aria-hidden="true"></i>
                              </button>
                              <button type="button" class="event-result-bench-team" (click)="setGamePlayerJersey(game, playerEventInfo.player.id, playerEventInfoJersey.BLACK)" [disabled]="resultSaving" [attr.aria-label]="('events.blackTeam' | translate) + ': ' + getPlayerDisplayName(playerEventInfo)">
                                <i [class]="('player.team' | nogoshIcon) + ' event-history-black-shirt'" aria-hidden="true"></i>
                              </button>
                            </div>
                          </div>
	                        }
		                      </div>
		                    }
		                  </section>
	                }
                <div class="event-result-add">
                  <button type="button" class="btn btn-outline-primary btn-sm" (click)="addResultGame()" [disabled]="resultSaving || resultLoading">
                    <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
                    {{ 'events.addGameRound' | translate }}
                  </button>
                </div>
                @if (resultErrorMsg) {
                  <p class="alert alert-danger py-2 mt-3 mb-0" role="alert">{{ resultErrorMsg }}</p>
                }
                @if (resultValidationMessage()) {
                  <p class="alert alert-warning py-2 mt-3 mb-0 text-center" role="status">{{ resultValidationMessage() }}</p>
                }
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="closeResultDialog()" [disabled]="resultSaving">{{ 'common.cancel' | translate }}</button>
                <button appSaveAction [saved]="matchInfoSaved" [saving]="resultSaving" type="button" class="btn btn-primary btn-sm px-3" (click)="saveResult()" [disabled]="resultSaving || resultLoading || !canSaveResult()">{{ 'common.save' | translate }}</button>
              </div>
            </app-dialog>
            @if (!loadingPlayersList) {
              <div class="rows player-tabbed-list">
                <div class="player-tabs-toolbar">
                  <div class="player-status-tabs" role="tablist" [attr.aria-label]="'events.players' | translate">
                    <button type="button" class="player-status-tab is-coming"
                      role="tab"
                      [class.is-active]="selectedPlayerListStatus === playerEventInfoStatus.CONFIRMED"
                      [title]="'guestOwner.coming' | translate"
                      [attr.aria-label]="'guestOwner.coming' | translate"
                      (click)="selectPlayerListStatus(playerEventInfoStatus.CONFIRMED)">
                      <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ playerListCount(playerEventInfoStatus.CONFIRMED) }}/{{ event.maxPlayers }}</span>
                    </button>
                    <button type="button" class="player-status-tab is-declined"
                      role="tab"
                      [class.is-active]="selectedPlayerListStatus === playerEventInfoStatus.DECLINED"
                      [title]="'guestOwner.notComing' | translate"
                      [attr.aria-label]="'guestOwner.notComing' | translate"
                      (click)="selectPlayerListStatus(playerEventInfoStatus.DECLINED)">
                      <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ playerListCount(playerEventInfoStatus.DECLINED) }}</span>
                    </button>
                    <button type="button" class="player-status-tab is-not-answered"
                      role="tab"
                      [class.is-active]="selectedPlayerListStatus === playerEventInfoStatus.NOT_ANSWERED"
                      [title]="'events.notAnswered' | translate"
                      [attr.aria-label]="'events.notAnswered' | translate"
                      (click)="selectPlayerListStatus(playerEventInfoStatus.NOT_ANSWERED)">
                      <i [class]="'match.status.notAnswered' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ playerListCount(playerEventInfoStatus.NOT_ANSWERED) }}</span>
                    </button>
                    <button type="button" class="player-status-tab is-not-notified"
                      role="tab"
                      [class.is-active]="selectedPlayerListStatus === playerEventInfoStatus.NOT_NOTIFIED"
                      [title]="'events.notInvited' | translate"
                      [attr.aria-label]="'events.notInvited' | translate"
                      (click)="selectPlayerListStatus(playerEventInfoStatus.NOT_NOTIFIED)">
                      <i [class]="'match.status.notNotified' | nogoshIcon" aria-hidden="true"></i>
                      <span>{{ playerListCount(playerEventInfoStatus.NOT_NOTIFIED) }}</span>
                    </button>
                  </div>
                  <div class="player-tabs-actions">
		                    @if ((event.viewedByManager && (canUseLiveMatchActions(event) || canAddHistoryAttendees(event))) || (!event.historyEvent && canViewStatsAndHistory(event))) {
	                      @if (event.viewedByManager && canUseLiveMatchActions(event) && selectedPlayerListStatus === playerEventInfoStatus.CONFIRMED) {
	                        <button type="button"
	                          class="player-action-icon"
	                          [disabled]="balanceTeamsInProgress"
	                          [title]="'events.balanceTeams' | translate"
	                          [attr.aria-label]="'events.balanceTeams' | translate"
	                          (click)="openBalanceTeamsPage()">
	                          @if (balanceTeamsInProgress) {
	                            <app-delayed-indicator></app-delayed-indicator>
	                          }
	                          @if (!balanceTeamsInProgress) {
	                            <i [class]="'match.balanceTeams' | nogoshIcon" aria-hidden="true"></i>
	                          }
	                        </button>
	                      }
		                      @if (event.viewedByManager && canUseLiveMatchActions(event)) {
	                        <button type="button"
	                          class="player-action-icon"
	                          [title]="'notifications.title' | translate"
	                          [attr.aria-label]="'notifications.title' | translate"
	                          (click)="openNotificationsPage()">
	                          <i [class]="'match.notifications' | nogoshIcon" aria-hidden="true"></i>
	                        </button>
	                        <button type="button"
	                          class="player-action-icon"
	                          [title]="'events.addPlayers' | translate"
	                          [attr.aria-label]="'events.addPlayers' | translate"
		                          (click)="openAddPlayersDialog()">
		                          <i [class]="'match.addPlayers' | nogoshIcon" aria-hidden="true"></i>
		                        </button>
		                      }
		                      @if (event.viewedByManager && canAddHistoryAttendees(event)) {
		                        <button type="button"
		                          class="player-action-icon"
		                          [title]="'events.addPlayers' | translate"
		                          [attr.aria-label]="'events.addPlayers' | translate"
		                          (click)="openAddPlayersDialog()">
		                          <i [class]="'match.addPlayers' | nogoshIcon" aria-hidden="true"></i>
		                        </button>
		                      }
	                      @if (!event.historyEvent && canViewStatsAndHistory(event)) {
                          @if (hasEnabledRulebook(event)) {
                            <button type="button"
                              class="player-action-icon"
                              [title]="'events.rulebook' | translate"
                              [attr.aria-label]="'events.rulebook' | translate"
                              (click)="openMatchRulesViewer()">
                              <i [class]="'match.rulebook' | nogoshIcon" aria-hidden="true"></i>
                            </button>
                          }
		                      <button type="button"
		                        class="player-action-icon"
		                        [title]="'stats.title' | translate"
		                        [attr.aria-label]="'stats.title' | translate"
		                        (click)="openStats(event)">
		                        <i [class]="'match.stats' | nogoshIcon" aria-hidden="true"></i>
		                      </button>
		                      <button type="button"
		                        class="player-action-icon"
		                        [title]="'events.history' | translate"
		                        [attr.aria-label]="'events.history' | translate"
		                        (click)="openHistory(event)">
		                        <i [class]="'match.history' | nogoshIcon" aria-hidden="true"></i>
		                      </button>
	                      }
	                  }
                    <button type="button"
                      class="player-action-icon"
                      [class.is-active]="showPlayerListSearch"
                      [title]="'events.searchPlayers' | translate"
                      [attr.aria-label]="'events.searchPlayers' | translate"
                      (click)="togglePlayerListSearch()">
                      <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
                    </button>
                    @if (canShowSettingsButton(event)) {
		                      <button type="button"
		                        class="player-action-icon"
		                        [title]="'common.more' | translate"
	                        [attr.aria-label]="'common.more' | translate"
	                        (click)="openSettingsPage()">
	                        <i [class]="'match.settings' | nogoshIcon" aria-hidden="true"></i>
	                      </button>
	                      }
                  </div>
                </div>
                @if (showPlayerListSearch) {
                  <div class="player-list-search-row">
                    <div class="player-list-search-box">
                      <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
                      <input type="search"
                        name="playerListSearch"
                        class="player-list-search-input"
                        autocomplete="off"
                        [placeholder]="'events.searchPlayersPlaceholder' | translate"
                        [(ngModel)]="playerListSearchText"
                        [ngModelOptions]="{standalone: true}">
                      @if (playerListSearchText) {
                        <button type="button"
                          class="player-list-search-clear"
                          [attr.aria-label]="'common.clear' | translate"
                          (click)="clearPlayerListSearch()">
                          <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                        </button>
                      }
                    </div>
                  </div>
                }
                @for (player of event.playerEventInfos | groupBy : 'status' | sortGroupedBy : 'key'; track player) {
                  @if (player.key === selectedPlayerListStatus) {
                  <div id="eventPlayersList" class="player-tab-panel">
                    @if (player.key === 'CONFIRMED' ) {
                      <div class="player-section-heading-row mt-3 d-flex justify-content-between align-items-center">
                        <b class="player-section-tab">{{ 'guestOwner.coming' | translate }} ({{ player.value.length }}/{{ event.maxPlayers }})</b>
                        @if (event.viewedByManager && canUseLiveMatchActions(event)) {
                          <button [disabled]="balanceTeamsInProgress"
                            class="btn  ml-sm-3 px-4 btn-outline-primary active" (click)="openBalanceTeamsPage()">
                            @if (balanceTeamsInProgress) {
                              <app-delayed-indicator></app-delayed-indicator>
                            }
                            {{ (balanceTeamsInProgress ? 'events.balancingTeams' : 'events.balanceTeams') | translate }}
                          </button>
                        }
                      </div>
                    }
                    <app-dialog [(visible)]="showBalanceTeamsDialog" [closable]="false" class="app-dialog--standard">
                      <div class="modal-header">
                        <h5 class="mb-0">{{ 'events.balanceTeamsSuccessTitle' | translate }}</h5>
                      </div>
                      @if (balanceTeamsResult) {
                        <div class="modal-body">
                          <p class="mb-2">{{ 'events.balanceTeamsSuccessMessage' | translate }}</p>
                          @if (balanceTeamsResult.calculation?.oddPlayerCount) {
                            <p class="text-nogosh-grey3 text-sm mb-2">
                              {{ 'events.balanceTeamsOddPlayers' | translate }}
                            </p>
                          }
                          @if (balanceTeamsResult.calculation?.fallbackRatingUsed) {
                            <p class="text-nogosh-grey3 text-sm mb-2">
                              {{ 'events.balanceTeamsFallbackUsed' | translate }}
                            </p>
                          }
                          @if (isGreedyBalanceAlgorithm(balanceTeamsResult)) {
                            <p class="text-nogosh-grey3 text-sm mb-2">
                              {{ 'events.balanceTeamsGreedyMode' | translate }}
                            </p>
                          }
                          <button type="button" class="btn btn-link px-0" (click)="toggleBalanceTeamsDetails()">
                            {{ (showBalanceTeamsDetails ? 'events.hideCalculation' : 'events.showCalculation') | translate }}
                          </button>
                          @if (showBalanceTeamsDetails) {
                            <div class="mt-3">
                              @if (balanceTeamsResult.calculation) {
                                <div>
                                  <h6>{{ 'events.summary' | translate }}</h6>
                                  <ul class="pl-3">
                                    <li>{{ 'events.confirmedPlayers' | translate }}: {{ balanceTeamsResult.calculation.confirmedPlayersCount }}</li>
                                    <li>{{ 'events.whiteTeam' | translate }}: {{ balanceTeamsResult.calculation.whiteTeamSize }} {{ 'events.players' | translate }}</li>
                                    <li>{{ 'events.blackTeam' | translate }}: {{ balanceTeamsResult.calculation.blackTeamSize }} {{ 'events.players' | translate }}</li>
                                    <li>{{ 'events.method' | translate }}: {{ 'events.balanceTeamsMethod' | translate }}</li>
                                  </ul>
                                  <h6>{{ 'events.teamComparison' | translate }}</h6>
                                  <div class="row">
                                    <div class="col-12 col-sm-6">
                                      <b>{{ 'events.whiteTeam' | translate }}</b>
                                      <ul class="pl-3">
                                        <li>{{ 'players.offence' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.calculation.whiteOffenceAverage) }}</li>
                                        <li>{{ 'players.defence' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.calculation.whiteDefenceAverage) }}</li>
                                        <li>{{ 'events.combinedAverage' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.calculation.whiteCombinedAverage) }}</li>
                                      </ul>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                      <b>{{ 'events.blackTeam' | translate }}</b>
                                      <ul class="pl-3">
                                        <li>{{ 'players.offence' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.calculation.blackOffenceAverage) }}</li>
                                        <li>{{ 'players.defence' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.calculation.blackDefenceAverage) }}</li>
                                        <li>{{ 'events.combinedAverage' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.calculation.blackCombinedAverage) }}</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              }
                              <h6>{{ 'events.difference' | translate }}</h6>
                              <ul class="pl-3">
                                <li>{{ 'players.offence' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.offenceDifference) }}</li>
                                <li>{{ 'players.defence' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.defenceDifference) }}</li>
                                <li>{{ 'events.total' | translate }}: {{ formatBalanceNumber(balanceTeamsResult.totalDifference) }}</li>
                              </ul>
                              <div class="row">
                                <div class="col-12 col-sm-6">
                                  <h6>{{ 'events.whiteTeam' | translate }}</h6>
                                  <ul class="list-unstyled">
                                    @for (playerResult of balanceTeamsResult.whiteTeam; track playerResult) {
                                      <li class="mb-2">
                                        <b>{{ playerResult.nickName }}</b>
                                        <div class="text-nogosh-grey3 text-sm">
                                          {{ playerResult.jersey }} · {{ 'players.offence' | translate }} {{ formatBalanceNumber(playerResult.averageOffence) }} · {{ 'players.defence' | translate }} {{ formatBalanceNumber(playerResult.averageDefence) }}
                                        </div>
                                        @if (playerResult.offenceFallbackUsed || playerResult.defenceFallbackUsed) {
                                          <span class="badge badge-status text-nogosh-grey3">
                                            {{ 'events.defaultRatingUsed' | translate }}
                                          </span>
                                        }
                                      </li>
                                    }
                                  </ul>
                                </div>
                                <div class="col-12 col-sm-6">
                                  <h6>{{ 'events.blackTeam' | translate }}</h6>
                                  <ul class="list-unstyled">
                                    @for (playerResult of balanceTeamsResult.blackTeam; track playerResult) {
                                      <li class="mb-2">
                                        <b>{{ playerResult.nickName }}</b>
                                        <div class="text-nogosh-grey3 text-sm">
                                          {{ playerResult.jersey }} · {{ 'players.offence' | translate }} {{ formatBalanceNumber(playerResult.averageOffence) }} · {{ 'players.defence' | translate }} {{ formatBalanceNumber(playerResult.averageDefence) }}
                                        </div>
                                        @if (playerResult.offenceFallbackUsed || playerResult.defenceFallbackUsed) {
                                          <span class="badge badge-status text-nogosh-grey3">
                                            {{ 'events.defaultRatingUsed' | translate }}
                                          </span>
                                        }
                                      </li>
                                    }
                                  </ul>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm px-3" (click)="closeBalanceTeamsDialog()">{{ 'common.close' | translate }}</button>
                      </div>
                    </app-dialog>
                    @if (player.key === 'NOT_ANSWERED' ) {
                      <div class="player-section-heading-row mt-3 d-flex align-items-end ">
                        <b class="player-section-tab">{{ 'events.notAnswered' | translate }} ({{ player.value.length }})</b>
                        @if (false) {
                          <div class="text-right d-inline-block ml-auto mb-n2 pr-2">
                            <a class="event-list-button btn-sm" [routerLink]="['/messages', {entityId: event.originalEventId}]">
                              <img src="../assets/images/notify_player.png"  style="width: 40px;" [alt]="'notifications.title' | translate">
                            </a>
                          </div>
                        }
                      </div>
                    }
                    @if (player.key === 'DECLINED' ) {
                      <div class="player-section-heading-row mt-3"><b class="player-section-tab">{{ 'guestOwner.notComing' | translate }} ({{ player.value.length }}/{{ event.maxPlayers }})</b></div>
                    }
                    @if (player.key === 'NOT_NOTIFIED' ) {
                      <div class="player-section-heading-row mt-3"><b class="player-section-tab">{{ 'events.notInvited' | translate }} ({{ player.value.length }})</b></div>
                    }
                    @if (visiblePlayerEventInfos(player.value, player.key).length > 0) {
                    <div class="players-list-wrapper player-section-card card">
                      @if (player.key === 'CONFIRMED') {
                        <div class="card-body px-3 py-0">
                          @for (playerEventInfo of visiblePlayerEventInfosForDisplay(player.value, player.key); track playerEventInfo) {
                            <div class="players-list py-2 border-bottom border-bottom-not-last cursor-pointer"
                              [class.is-light-team-player]="confirmedTeamsAreDivided(player.value) && isWhiteTeamPlayer(playerEventInfo)"
                              [class.is-dark-team-player]="confirmedTeamsAreDivided(player.value) && isBlackTeamPlayer(playerEventInfo)"
                              role="button"
                              tabindex="0"
                              (click)="openMngPlayerDetail(playerEventInfo, event)"
                              (keydown.enter)="openMngPlayerDetail(playerEventInfo, event)"
                              (keydown.space)="openMngPlayerDetail(playerEventInfo, event); $event.preventDefault()">
                              <div class="row player-row align-items-center">
                                <!-- avatar -->
                                <div class="col-auto pr-2 pr-sm-3">
                                  <div class="avatar-team player-team-avatar"
                                    [class.is-current-player-avatar]="isCurrentPlayer(playerEventInfo)"
                                    [class.is-manager-avatar]="isManagerPlayer(playerEventInfo)"
                                    [class.is-manager-added-avatar]="!isManagerPlayer(playerEventInfo) && isGuestPlayer(playerEventInfo.player)"
                                    [class.is-first-team-avatar]="!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isFirstTeamPlayer(playerEventInfo)"
                                    [class.is-reserve-avatar]="!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isReservePlayer(playerEventInfo)"
                                    [title]="isManagerPlayer(playerEventInfo) ? ('common.manager' | translate) : isGuestPlayer(playerEventInfo.player) ? accountlessPlayerLabel(playerEventInfo.player) : playerTeamMemberLabel(playerEventInfo)"
                                    [attr.aria-label]="isManagerPlayer(playerEventInfo) ? ('common.manager' | translate) : isGuestPlayer(playerEventInfo.player) ? accountlessPlayerLabel(playerEventInfo.player) : playerTeamMemberLabel(playerEventInfo)">
                                  @if (playerEventInfo.player.avatar) {
                                    <img [src]="playerEventInfo.player.avatar"
                                      onerror="this.src='../../assets/images/user1.jpg'" class="rounded-circle border" style="width: 40px; height: 40px"
                                      [alt]="'accessibility.userProfileImage' | translate">
                                  } @else {
                                    <span class="rounded-circle border player-avatar-fallback avatar-team-fallback"
                                      [ngClass]="playerEventInfoAvatarTone(playerEventInfo)" aria-hidden="true">{{getPlayerInitials(playerEventInfo)}}</span>
                                  }
                                    @if (isManagerPlayer(playerEventInfo)) {
                                      <span class="player-team-status-icon" aria-hidden="true">
                                        M
                                      </span>
                                    }
                                    @if (!isManagerPlayer(playerEventInfo) && isGuestPlayer(playerEventInfo.player)) {
                                      <span class="player-team-status-icon" aria-hidden="true">
                                        <i [class]="'match.inviteGuest' | nogoshIcon"></i>
                                      </span>
                                    }
                                    @if (!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isFirstTeamPlayer(playerEventInfo)) {
                                      <span class="player-team-status-icon" aria-hidden="true">
                                        <i [class]="'match.status.firstTeam' | nogoshIcon"></i>
                                      </span>
                                    }
                                    @if (!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isReservePlayer(playerEventInfo)) {
                                      <span class="player-team-status-icon player-team-status-letter" aria-hidden="true">
                                        R
                                      </span>
                                    }
                                  </div>
                                </div>
                                <!-- nickname -->
                                <div class="col pl-0 text-sm font-weight-500 players-nickname d-flex flex-column justify-content-center line-height-10"
                                  title="{{playerEventInfo.player.nickName}}">
                                  {{playerEventInfo.player.nickName}}
                                </div>
                                <!-- jersey -->
                                @if (event.active && event.viewedByManager && !editMode && canUseLiveMatchActions(event) && playerEventInfo.status === playerEventInfoStatus.CONFIRMED) {
                                  <div class="match-player-jersey-action ml-auto mr-4 d-flex align-items-center"
                                    (click)="$event.stopPropagation()"
                                    [title]="'accessibility.toggleJersey' | translate">
                                    @if (playerEventInfo.jersey === playerEventInfoJersey.WHITE) {
	                                      <a href="javascript:" class="text-secondary" [title]="'accessibility.changeJerseyLight' | translate">
                                        <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="toggleSubteamJersey(playerEventInfo); $event.preventDefault(); $event.stopPropagation()"></i>
                                      </a>
                                    }
                                    @if (playerEventInfo.jersey === playerEventInfoJersey.BLACK) {
	                                      <a href="javascript:" class="text-primary" [title]="'accessibility.changeJerseyDark' | translate">
                                        <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="toggleSubteamJersey(playerEventInfo); $event.preventDefault(); $event.stopPropagation()"></i>
                                      </a>
                                    }
                                  </div>
                                }
                                @if (event.active && (!event.viewedByManager || !canUseLiveMatchActions(event))) {
                                  <div class="match-player-jersey-action ml-auto mr-4 d-flex align-items-center" (click)="$event.stopPropagation()">
                                    @if (playerEventInfo.status === playerEventInfoStatus.CONFIRMED) {
                                      <div>
                                        @if (playerEventInfo.jersey === playerEventInfoJersey.WHITE) {
                                          <span class="text-secondary" [title]="'accessibility.jerseyLight' | translate">
                                            <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="$event.preventDefault(); $event.stopPropagation()"></i>
                                          </span>
                                        }
                                        @if (playerEventInfo.jersey === playerEventInfoJersey.BLACK) {
                                          <span class="text-primary" [title]="'accessibility.jerseyDark' | translate">
                                            <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="$event.preventDefault(); $event.stopPropagation()"></i>
                                          </span>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                <!-- arrow -->
                                <div  class="col-auto align-items-center">
                                  <i [class]="('match.chevronForward' | nogoshIcon) + ' h3 m-0'" ></i>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @if (player.key !=='CONFIRMED') {
                        <div class="card-body px-3 py-0">
                          @if (hasFirstTeamPlayers(player.value, player.key)) {
                            <div class="player-list-team-break player-list-team-break-first">
	                              <span>{{ 'notifications.firstTeam' | translate }}</span>
                            </div>
                          }
                          @for (playerEventInfo of visiblePlayerEventInfosForDisplay(player.value, player.key); track playerEventInfo) {
                            @if (playerEventInfo.teamMemberType !==teamMemberType.CANDIDATE) {
                              <!-- *ngIf="playerEventInfo.teamMemberType !==teamMemberType.CANDIDATE" -->
                              <div class="players-list py-2 border-bottom border-bottom-not-last cursor-pointer"
                                [class.is-first-team-player]="isFirstTeamPlayer(playerEventInfo)"
                                [class.is-reserve-player]="isReservePlayer(playerEventInfo)"
                                [attr.data-team-break-label]="isReservePlayer(playerEventInfo) ? ('notifications.reserves' | translate) : null"
                                role="button"
                                tabindex="0"
                                (click)="openMngPlayerDetail(playerEventInfo, event)"
                                (keydown.enter)="openMngPlayerDetail(playerEventInfo, event)"
                                (keydown.space)="openMngPlayerDetail(playerEventInfo, event); $event.preventDefault()">
                                <div class="row player-row align-items-center">
                                  <!-- avatar -->
                                  <div class="col-auto pr-2 pr-sm-3">
                                    <div class="avatar-team player-team-avatar"
                                      [class.is-current-player-avatar]="isCurrentPlayer(playerEventInfo)"
                                      [class.is-manager-avatar]="isManagerPlayer(playerEventInfo)"
                                      [class.is-manager-added-avatar]="!isManagerPlayer(playerEventInfo) && isGuestPlayer(playerEventInfo.player)"
                                      [class.is-first-team-avatar]="!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isFirstTeamPlayer(playerEventInfo)"
                                      [class.is-reserve-avatar]="!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isReservePlayer(playerEventInfo)"
                                      [title]="isManagerPlayer(playerEventInfo) ? ('common.manager' | translate) : isGuestPlayer(playerEventInfo.player) ? accountlessPlayerLabel(playerEventInfo.player) : playerTeamMemberLabel(playerEventInfo)"
                                      [attr.aria-label]="isManagerPlayer(playerEventInfo) ? ('common.manager' | translate) : isGuestPlayer(playerEventInfo.player) ? accountlessPlayerLabel(playerEventInfo.player) : playerTeamMemberLabel(playerEventInfo)">
                                      @if (playerEventInfo.player.avatar) {
                                        <img [src]="playerEventInfo.player.avatar"
                                          onerror="this.src='../../assets/images/user1.jpg'" class="rounded-circle border" style="width: 40px; height: 40px"
                                          [alt]="'accessibility.userProfileImage' | translate">
                                      } @else {
                                        <span class="rounded-circle border player-avatar-fallback avatar-team-fallback"
                                          [ngClass]="playerEventInfoAvatarTone(playerEventInfo)" aria-hidden="true">{{getPlayerInitials(playerEventInfo)}}</span>
                                      }
                                      @if (isManagerPlayer(playerEventInfo)) {
                                        <span class="player-team-status-icon player-team-status-letter" aria-hidden="true">
                                          M
                                        </span>
                                      }
                                      @if (!isManagerPlayer(playerEventInfo) && isGuestPlayer(playerEventInfo.player)) {
                                        <span class="player-team-status-icon" aria-hidden="true">
                                          <i [class]="'match.inviteGuest' | nogoshIcon"></i>
                                        </span>
                                      }
                                      @if (!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isFirstTeamPlayer(playerEventInfo)) {
                                        <span class="player-team-status-icon" aria-hidden="true">
                                          <i [class]="'match.status.firstTeam' | nogoshIcon"></i>
                                        </span>
                                      }
                                      @if (!isManagerPlayer(playerEventInfo) && !isGuestPlayer(playerEventInfo.player) && isReservePlayer(playerEventInfo)) {
                                        <span class="player-team-status-icon player-team-status-letter" aria-hidden="true">
                                          R
                                        </span>
                                      }
                                    </div>
                                  </div>
                                  <!-- nickname -->
                                  <div class="col pl-0 text-sm font-weight-500 players-nickname d-flex flex-column justify-content-center line-height-10"
                                    title="{{playerEventInfo.player.nickName}}">
                                    {{playerEventInfo.player.nickName}}
                                  </div>
                                  <!-- jersey -->
                                  @if (event.active && event.viewedByManager && !editMode && canUseLiveMatchActions(event) && playerEventInfo.status === playerEventInfoStatus.CONFIRMED) {
                                    <div class="match-player-jersey-action ml-auto mr-4 d-flex align-items-center"
                                      (click)="$event.stopPropagation()"
                                      [title]="'accessibility.toggleJersey' | translate">
                                      @if (playerEventInfo.jersey === playerEventInfoJersey.WHITE) {
	                                        <a href="javascript:" class="text-secondary" [title]="'accessibility.changeJerseyLight' | translate">
                                          <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="toggleSubteamJersey(playerEventInfo); $event.preventDefault(); $event.stopPropagation()"></i>
                                        </a>
                                      }
                                      @if (playerEventInfo.jersey === playerEventInfoJersey.BLACK) {
	                                        <a href="javascript:" class="text-primary" [title]="'accessibility.changeJerseyDark' | translate">
                                          <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="toggleSubteamJersey(playerEventInfo); $event.preventDefault(); $event.stopPropagation()"></i>
                                        </a>
                                      }
                                    </div>
                                  }
                                  @if (event.active && (!event.viewedByManager || !canUseLiveMatchActions(event))) {
                                    <div class="match-player-jersey-action ml-auto mr-4 d-flex align-items-center" (click)="$event.stopPropagation()">
                                      @if (playerEventInfo.status === playerEventInfoStatus.CONFIRMED) {
                                        <div>
                                          @if (playerEventInfo.jersey === playerEventInfoJersey.WHITE) {
                                            <span class="text-secondary" [title]="'accessibility.jerseyLight' | translate">
                                              <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="$event.preventDefault(); $event.stopPropagation()"></i>
                                            </span>
                                          }
                                          @if (playerEventInfo.jersey === playerEventInfoJersey.BLACK) {
                                            <span class="text-primary" [title]="'accessibility.jerseyDark' | translate">
                                              <i [class]="('player.team' | nogoshIcon) + ' h2 m-0 match-player-jersey-icon'" (click)="$event.preventDefault(); $event.stopPropagation()"></i>
                                            </span>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                  <!-- arrow -->
                                  <div  class="col-auto align-items-center">
                                    <i [class]="('match.chevronForward' | nogoshIcon) + ' h3 m-0'" ></i>
                                  </div>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                    }
                  </div>
                }
                }
                @if (filteredPlayerListCount(selectedPlayerListStatus) === 0) {
                  <div class="player-tab-panel">
                    <div class="players-list-wrapper player-section-card card">
                      <div class="card-body px-3 py-3 text-nogosh-grey3 text-center">
                        {{ (playerListCount(selectedPlayerListStatus) === 0 ? 'events.noPlayersForSelectedStatus' : 'common.noResults') | translate }}
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </form>
    }
    </app-screen-shell>
  }
